import { Component, OnDestroy, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { addDays, format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { RadialGauge } from 'canvas-gauges';
import { Chart } from 'chart.js/auto';
import { FormControl, FormGroup } from '@angular/forms';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Error429Service } from 'src/app/services/error429.service';
import { environment } from "./../../../../environments/environment";
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UserDataService } from 'src/app/services/user-data.service';
import { ToastrService } from 'ngx-toastr';
import { MapService } from 'src/app/services/map.service';
interface Escala {
  value: string;
  viewValue: string;
}
interface DatosTanque {
  deviceId: number;
  slot: number;
  consumo: number;
}
@Component({
  selector: 'app-ver-dispositivo',
  templateUrl: './ver-dispositivo.component.html',
  styleUrls: ['./ver-dispositivo.component.css']
})
export class VerDispositivoComponent implements OnDestroy{
  userDevices: any = []; //Información básica los clientes
  establishmentData: any = []; //Información de los establecimientos
  alarmas: any = [];
  alarmasActivadas: any = [];
  deviceHistoryMap: { [deviceReference: string]: any } = {}; //Historial de los dispositivos
  errorMessage : string =""; //Mensaje de error
  urlMap: any; //url del mapa
  currentPath: string = ""; //Ruta actual
  dev_reference: string = "";
  dev_label: string = "";
  dev_id: string = "";
  dev_create_at: string = "";
  activado: boolean = false; //Dispositivo activado 
  dev_img: string = ""; //Imagen del dispositivo
  dev_img_path: string = "";
  lat: number = 43.0081016;
  lng: number = -7.5561412;
  zoom: number = 10;
  //Datos del último histórico
    fechaDelUltimoHistorico: string ="";
    temperaturaAmbiente: string = "";
    nivelT1 :string = "0";
    nivelT2 :string = "0";
    nivelT3 :string = "0";
    nivelT4 :string = "0";
    temperaturaT1: string = "0";
    temperaturaT2: string = "0";
    temperaturaT3: string = "0";
    temperaturaT4: string = "0";
    presionT1: string = "0";
    presionT2: string = "0";
    presionT3: string = "0";
    presionT4: string = "0";
    capacidadT1: string = "0";
    capacidadT2: string = "0";
    capacidadT3: string = "0";
    capacidadT4: string = "0";
    consumidosT1: string = "0.0";
    consumidosT2: string = "0.0";
    consumidosT3: string = "0.0";
    consumidosT4: string = "0.0";
    tipoCervezaT1: string = "";
    tipoCervezaT2: string = "";
    tipoCervezaT3: string = "";
    tipoCervezaT4: string = "";
    imagenCervezaT1: string = "";
    imagenCervezaT2: string = "";
    imagenCervezaT3: string = "";
    imagenCervezaT4: string = "";
    imagenCervezaT1Url: string = "";
    imagenCervezaT2Url: string = "";
    imagenCervezaT3Url: string = "";
    imagenCervezaT4Url: string = "";
    numeroTanque1: string = "";
    numeroTanque2: string = "";
    numeroTanque3: string = "";
    numeroTanque4: string = "";
  datosRecibidos1: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  datosRecibidos2: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  datosRecibidos3: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  alarmRangesTanks: any[] = [];
  displayedColumns: string[] = ['f_inicio', 'f_fin', 'type', 'rango'];
  displayedColumnsActivas: string[] = ['f_inicio', 'type', 'rango'];
  charts: Chart[] = []; //Información de los charts para poder eliminarlos
  // Condición para ver si el borde de la imagen es verde
    condicionT1Activo: boolean = false;
    condicionT2Activo: boolean = false;
    condicionT3Activo: boolean = false;
    condicionT4Activo: boolean = false;
  // Condición para mostrar o no el tanque
    verT1: boolean = false;
    verT2: boolean = false;
    verT3: boolean = false;
    verT4: boolean = false;
  //Colores de las gráficas
    gradientStroke: any;
    gradientStroke2: any;
    gradientStroke3: any;
    gradientFill: any;
    gradientFill2: any;
    gradientFill3: any;

  //GRAFICAS CARGADAS
  fechaCambiadaGraficasCargardas: boolean = false;
  diaActualIncluido: boolean = true;
  readersRawDiaActual: any = [];

  //ESTADISTICAS
  datosEstadisticosTemperatura: any = [];
  datosEstadisticosTemperaturaTodos: any = [];
  datosEstadisticosPresion: any = [];
  datosEstadisticosPresionTodos: any = [];
  datosEstadisticosNivel: any = [];
  datosEstadisticosConsumo: any = [];
  datosEstadisticosConsumoTodos: any = [];
  panelEstadisticasAbierto: boolean = false;

  //NO HAY DATOS
  graficasDatos: boolean = true;
  mensajeNoHayDatos: string = "(No hay datos disponibles en las fechas seleccionadas)";

  //DINAMICO
  tanksInfo:any [] = [];
  gaugesCargados: boolean = false;

  // PEDIDOS Y RECARGAS
    establecimientos: any = [];
    pedidos: any = [];
    recargas: any = [];

  idIncorrectoError: boolean = false;
  stringTitulosTiempo: string = "Fecha (Día/Mes/Año HH:mm)";
  dispositivoId: any = [];
  dispostivoData: any = [];
  hayAlarmas: boolean = false;
  hayAlarmasActivadas: boolean = false;
  hayAlarmasDesactivadas: boolean = false;
  diferenciaDias: number = 0;
  consumoDiaActual: any = [];
  litrosConsumidosPorTanque: DatosTanque[] = [];

  /*-------------------------------FechaActualConGuiones------------------------------------------*/
  fechaActualD = new Date();
  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate(); // Obtener el día del mes actual
  mes: number = this.fechaActual.getMonth(); // Los meses comienzan en 0, por lo que enero es 0 y diciembre es 11)
  anio: number = this.fechaActual.getFullYear(); // Obtener el año actual
  mes1 = this.mes + 1; // Los meses comienzan desde 0, por lo que se suma 1
  fechaFormateada = `${this.anio}-${this.mes1.toString().padStart(2, '0')}-${this.dia.toString().padStart(2, '0')}`;
  /*-------------------------------FechaActualConGuiones------------------------------------------*/

  /*-------------------------------Suscripciones------------------------------------------*/
  private establishmentSubscription: Subscription | undefined;
  private alarmsSubscription: Subscription | undefined;
  private historialSubscription: Subscription | undefined;
  private establishment1Subscription: Subscription | undefined;
  private tanksSubscription: Subscription | undefined;
  private beersSubscription: Subscription | undefined;
  private agregarPedidoSubscription: Subscription | undefined;
  private historicoDiaSubscription: Subscription | undefined;
  private establecimientosSubscription: Subscription | undefined;
  private pedidosSubscription: Subscription | undefined;
  private recargasSubscription: Subscription | undefined;
  private historialRawSubscription: Subscription | undefined;

  /*-------------------------------Seleccionar fecha para los gráficos------------------------------------------*/
  selectedDate = new FormGroup({
    start: new FormControl(new Date(this.anio, this.mes, this.dia)),
    end: new FormControl(new Date(this.anio, this.mes, this.dia)),
  });
  /*-------------------------------Seleccionar escala para los gráficos------------------------------------------*/
  selectedValue: string = "5";
  escalas: Escala[] = [
    {value: '5', viewValue: 'Mínima'},
    {value: '15', viewValue: '15 minutos'},
    {value: '30', viewValue: '30 minutos'},
    {value: '60', viewValue: '60 minutos'},
  ];
  urlBase: string = "";

  //TABLA TANQUES
  displayedColumnsTanques: string[] = ['nombreTanque','numero','espacio', 'cerveza', 'capacidad', 'operaciones'];
  dataSource :any;
  dataSourceAlarms: any;
  dataSourceAlarmsActivas: any;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('paginator1') paginator1!: MatPaginator;
  tanksData: any;
  tablaData: any [] = [];
  beersData: any;
  map: any; 
  marker: any;

  //ACTUALIZAR DATOS
  intervalId: any;
  tamañoHistorOriginal: number = 0;
  chartT : any;
  chartP : any;
  chartNC: any;
  gaugeNivel1: any;
  gaugeNivel2: any;
  gaugeNivel3: any;
  gaugeNivel4: any;
  gaugeTemperatura1: any;
  gaugeTemperatura2: any;
  gaugeTemperatura3: any;
  gaugeTemperatura4: any;
  gaugePresion1: any;
  gaugePresion2: any;
  gaugePresion3: any;
  gaugePresion4: any;

  @ViewChild('sort1') sort1!: MatSort;
  @ViewChild('sort2') sort2!: MatSort;
  @ViewChild('sort3') sort3!: MatSort;

  userServiceData: any = [];
  actualizar: boolean = false;
  waitAfterSave: boolean = false;

  // LLAMADAS 
    llamarOptimizada: boolean = false;

  // GRAFICAS
    spanGaps: number = 1250 * 60 * 60;
    escalaDias: boolean = false;

  constructor(private deviceService: DeviceService, private sanitizer:DomSanitizer, private router: Router,
    private error429: Error429Service, private userDataService: UserDataService,
    private toastr: ToastrService, private mapService: MapService){
    this.currentPath = this.router.url;
    this.dispositivoId.push(this.getDeviceIdFromPath(this.currentPath));
    this.urlBase = environment.urlNonce;
    this.userServiceData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    let recargarGafica = true;
    const fechaOriginal = new Date(this.fechaFormateada);
    const fechaSumada = new Date(fechaOriginal);
    fechaSumada.setDate(fechaOriginal.getDate() + 1);
    //this.getDevicesData(this.fechaFormateada, fechaSumada.toISOString().split("T")[0], this.selectedValue, recargarGafica, actualizar);
    this.getDatos(this.fechaFormateada, fechaSumada.toISOString().split("T")[0], this.selectedValue, recargarGafica, this.actualizar);
    //Actualizar los datos cada 60 segundos
    this.intervalId = setInterval(() => {
      const start = this.convertirFechaInicioParaApi();
      const end = this.convertirFechaFinParaApi();
      const fechaOriginal = new Date(end);
      const fechaSumada = new Date(fechaOriginal);
      //Los gráficas de la consulta de históricos solo se recargan si el día de hoy está incluido
      if(this.isFechaFormateadaInRange(start,fechaSumada.toISOString().split("T")[0])){
        recargarGafica = true;
        //this.fechaCambiadaGraficasCargardas = false;
      } else {
        recargarGafica = false;
      }
      fechaSumada.setDate(fechaOriginal.getDate() + 1);
      //Se mantiene la fecha y la escala si se han cambiado para las gráficas
      this.actualizar = true;
      //this.getDevicesData(start, fechaSumada.toISOString().split("T")[0], this.selectedValue, recargarGafica, actualizar);
      this.getDatos(start, fechaSumada.toISOString().split("T")[0], this.selectedValue, recargarGafica, this.actualizar);
    },15000)
  }

  isFechaFormateadaInRange(start: string, end: string): boolean {
    const fechaFormateada = new Date(this.fechaFormateada);
    const startDate = new Date(start);
    const endDate = new Date(end);
  
    // Ajusta las fechas para ignorar la hora exacta
    fechaFormateada.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
  
    return fechaFormateada >= startDate && fechaFormateada <= endDate;
  }

  manejarCierrePanel(): void {
    this.panelEstadisticasAbierto = false;
  }

  manejarAperturaPanel(): void {
    this.panelEstadisticasAbierto = true;
  }

  getDatos(chartStart: string, chartEnd: string, timeScale: string, recargarGafica: boolean, actualizar: boolean){
    this.tanksData = [];
    this.beersData = [];
    this.alarmas = [];
    this.alarmasActivadas = [];
    this.tablaData = [];
    //TABLA DE TANQUES
    this.tanksSubscription = this.deviceService.getTanks().subscribe({
      next:resp =>{
        const dispositivoId = this.getDeviceIdFromPath(this.currentPath);
        this.tanksData = resp.filter((tank:any) => tank.device_id === dispositivoId);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.beersSubscription = this.deviceService.getBeerType().subscribe({
          next:resp =>{
            this.beersData = resp;
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete:()=>{
            //TABLA DE ALARMAS
            const fechaActualStart = new Date();
            fechaActualStart.setDate(fechaActualStart.getDate() + 1);
            const fechaFormatedaEnd = fechaActualStart.toISOString().split('T')[0];
        
            const alarmasDispositivo = new FormData();    
            alarmasDispositivo.append('devices', JSON.stringify(this.dispositivoId));
            alarmasDispositivo.append('start', "2015-01-01");
            alarmasDispositivo.append('end', fechaFormatedaEnd);
        
            this.alarmsSubscription = this.deviceService.getAlarmasDevices(alarmasDispositivo).subscribe({
              next:resp =>{
                for(let i = 0; i < resp.alarms.length; i++){
                  if(resp.alarms[i].status !== 1){
                    //Alarmas DESACTIVADAS
                    const tankJson = JSON.parse(resp.alarms[i].tank);
                    let alarmRange = "-";
                    if(tankJson){
                      const alarmRanges = JSON.parse(tankJson.alarm_ranges);
                      if(resp.alarms[i].type == "L1" || resp.alarms[i].type == "L2" || resp.alarms[i].type == "L3" || resp.alarms[i].type == "L4"){
                        alarmRange = "Nivel de cerveza mínimo: " + this.soloDosDecimalesConComa(alarmRanges.beerLevelMin) + "%";
                      }
                      if(resp.alarms[i].type == "A1" || resp.alarms[i].type == "A2" || resp.alarms[i].type == "A3" || resp.alarms[i].type == "A4"){
                        alarmRange = "Temperatura máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMax) + "ºC";
                      }
                      if(resp.alarms[i].type == "B1" || resp.alarms[i].type == "B2" || resp.alarms[i].type == "B3" || resp.alarms[i].type == "B4"){
                        alarmRange = "Temperatura mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin) + "ºC";
                      }
                      if(resp.alarms[i].type == "C1" || resp.alarms[i].type == "C2" || resp.alarms[i].type == "C3" || resp.alarms[i].type == "C4"){
                        if(alarmRanges.beerPressureMax == 1){
                          alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bar";
                        } else {
                          alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bares";
                        }
                      }
                      if(resp.alarms[i].type == "D1" || resp.alarms[i].type == "D2" || resp.alarms[i].type == "D3" || resp.alarms[i].type == "D4"){
                        if(alarmRanges.beerPressureMin == 1){
                          alarmRange = "Presión mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bar";
                        } else {
                          alarmRange = "Presión mímina: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bares";
                        }
                      }
                    }
                    let type = resp.alarms[i].desc2;
                    this.alarmas.push({
                      f_inicio: resp.alarms[i].started_at ?? "-",
                      f_fin: resp.alarms[i].ended_at ?? "-", 
                      type: type ?? "-",
                      rango: alarmRange
                    });
                  } else {
                    //Alarmas ACTIVADAS
                    const tankJson = JSON.parse(resp.alarms[i].tank);
                    let alarmRange = "-";
                    if(tankJson){
                      const alarmRanges = JSON.parse(tankJson.alarm_ranges);
                      if(resp.alarms[i].type == "L1" || resp.alarms[i].type == "L2" || resp.alarms[i].type == "L3" || resp.alarms[i].type == "L4"){
                        alarmRange = "Nivel de cerveza mínimo: " + this.soloDosDecimalesConComa(alarmRanges.beerLevelMin) + "%";
                      }
                      if(resp.alarms[i].type == "A1" || resp.alarms[i].type == "A2" || resp.alarms[i].type == "A3" || resp.alarms[i].type == "A4"){
                        alarmRange = "Temperatura máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMax) + "ºC";
                      }
                      if(resp.alarms[i].type == "B1" || resp.alarms[i].type == "B2" || resp.alarms[i].type == "B3" || resp.alarms[i].type == "B4"){
                        alarmRange = "Temperatura mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin) + "ºC";
                      }
                      if(resp.alarms[i].type == "C1" || resp.alarms[i].type == "C2" || resp.alarms[i].type == "C3" || resp.alarms[i].type == "C4"){
                        if(alarmRanges.beerPressureMax == 1){
                          alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bar";
                        } else {
                          alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bares";
                        }
                      }
                      if(resp.alarms[i].type == "D1" || resp.alarms[i].type == "D2" || resp.alarms[i].type == "D3" || resp.alarms[i].type == "D4"){
                        if(alarmRanges.beerPressureMin == 1){
                          alarmRange = "Presión mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bar";
                        } else {
                          alarmRange = "Presión mímina: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bares";
                        }
                      }
                    }
                    let type = resp.alarms[i].desc2;
                    this.alarmasActivadas.push({
                      f_inicio: resp.alarms[i].started_at ?? "-",
                      type: type ?? "-",
                      type_symbol:  resp.alarms[i].type,
                      rango: alarmRange
                    });
                  }
                }
              },error:err =>{
                if (err.status == 429) {
                  this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                  this.recargarPaginaDespuesDeTiempo();
                } else {
                  this.errorMessage = err.error.message;
                }
              },complete:() =>{
                this.getDevicesData(chartStart, chartEnd, timeScale, recargarGafica, actualizar);
                //ALARMAS ACTIVADAS
                if(this.alarmas.length == 0){
                  this.hayAlarmasDesactivadas = false;
                } else {
                  this.hayAlarmasDesactivadas = true;
                }
                this.dataSourceAlarms = new MatTableDataSource(this.alarmas);
                if(actualizar){
                  setTimeout(() => {
                    this.dataSourceAlarms.sort = this.sort3;
                    this.dataSourceAlarms.paginator = this.paginator1;
                  }, 0);
                }
    
                //ALARMAS ACTIVADAS
                if(this.alarmasActivadas.length == 0){
                  this.hayAlarmasActivadas = false;
                } else {
                  this.hayAlarmasActivadas = true;
                }
                this.dataSourceAlarmsActivas = new MatTableDataSource(this.alarmasActivadas);
                if(actualizar){
                  setTimeout(() => {
                    this.dataSourceAlarmsActivas.sort = this.sort2;
                  }, 0);
                }
    
                //TABLA DE TANQUES
                for(let i=0; i<this.tanksData.length; i++){
                  const tankData: any = {
                    id: this.tanksData[i].id,
                    nombreTanque: this.tanksData[i].external_id,
                    espacio: this.tanksData[i].slot,
                    numero: this.tanksData[i].custom_num,
                    cerveza: this.obtenerNombreCerveza(this.tanksData[i].beer_type_id),
                    capacidad: this.tanksData[i].capacity,
                  }
                  this.tablaData.push(tankData);
                }
                this.dataSource = new MatTableDataSource(this.tablaData); 
                if(actualizar){
                  setTimeout(() => {
                    this.dataSource.sort = this.sort1;
                  }, 0);
                }
              }
            });
          }
        });
      }
    });
  }

  existeAlarmaConTypeSymbol(typeSymbol: string): boolean {
    return this.alarmasActivadas && this.alarmasActivadas.some((alarma:any) => alarma.type_symbol === typeSymbol);
  }

  soloDosDecimalesConString(cadena: string){
    let numero;
    numero = parseFloat(cadena);
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userServiceData.region, { maximumFractionDigits: 2 });
    }
  }

  soloDosDecimalesConComa(numero: number){
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userServiceData.region, { maximumFractionDigits: 2 });
    }
  }

  obtenerNombreCerveza(id: number): string {
    const cerveza = this.beersData.find((beer:any) => beer && beer.id === id);
    return cerveza ? cerveza.name : 'Cerveza no encontrada';
  }

  obtenerImagenCerveza(id: number): string{
    const cerveza = this.beersData.find((beer:any) => beer && beer.id === id);
    return cerveza ? cerveza.img : 'Cerveza no encontrada';
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    }
    if (this.alarmsSubscription) {
      this.alarmsSubscription.unsubscribe();
    }
    if (this.historialSubscription) {
      this.historialSubscription.unsubscribe();
    }
    if (this.establishment1Subscription) {
      this.establishment1Subscription.unsubscribe();
    }
    if (this.tanksSubscription) {
      this.tanksSubscription.unsubscribe();
    }
    if (this.beersSubscription) {
      this.beersSubscription.unsubscribe();
    }
    if (this.agregarPedidoSubscription) {
      this.agregarPedidoSubscription.unsubscribe();
    }
    if (this.historicoDiaSubscription) {
      this.historicoDiaSubscription.unsubscribe();
    }
    if (this.establecimientosSubscription) {
      this.establecimientosSubscription.unsubscribe();
    }
    if (this.pedidosSubscription) {
      this.pedidosSubscription.unsubscribe();
    }
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    }
    if (this.historialRawSubscription) {
      this.historialRawSubscription.unsubscribe();
    }
    clearInterval(this.intervalId);
  }

  getNewGraphicDate(){
    const timescale = this.selectedValue;
    const start = this.convertirFechaInicioParaApi();
    const end = this.convertirFechaFinParaApi();
    if(start !== "Fecha de inicio no seleccionada" && end !== "Fecha fin no seleccionada"){
      this.graficasDatos = true;
      this.fechaCambiadaGraficasCargardas = false;
      const fechaOriginal = new Date(end);
      const fechaSumada = new Date(fechaOriginal);
      //Sumarle uno a la fecha end para que devuelva bien los datos la api
      fechaSumada.setDate(fechaOriginal.getDate() + 1);
      this.loadTodayCharts(this.dev_reference, start, fechaSumada.toISOString().split("T")[0], timescale);
    } else {
      this.destroyCharts();
      this.graficasDatos = false;
      this.mensajeNoHayDatos = "(Selecciona una fecha correcta)";
    }
  }

  descargarExcel(): void {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');
  
    worksheet.columns = [
      //{ header: 'Id', key: 'id', width: 15 },
      { header: 'Fecha', key: 'created_at', width: 20 },
      //{ header: 'Tensión Eléctrica', key: 'field1', width: 17 },
      { header: 'Tanque Activo', key: 'field2', width: 15 },
      { header: 'Presión Tanque 1', key: 'field3', width: 17 },
      { header: 'Presión Tanque 2', key: 'field4', width: 17 },
      { header: 'Presión Tanque 3', key: 'field5', width: 17 },
      { header: 'Presión Tanque 4', key: 'field23', width: 17 },
      { header: 'Temperatura Tanque 1', key: 'field6', width: 20 },
      { header: 'Temperatura Tanque 2', key: 'field7', width: 20 },
      { header: 'Temperatura Tanque 3', key: 'field8', width: 20 },
      { header: 'Temperatura Tanque 4', key: 'field24', width: 20 },
      { header: 'Temperatura Exterior', key: 'field9', width: 15 },
      //{ header: 'Sensor Extra', key: 'field10', width: 15 },
      { header: 'Caudal 1 Tanque 1', key: 'field11', width: 20 },
      { header: 'Caudal 2 Tanque 1', key: 'field12', width: 20 },
      { header: 'Caudal 3 Tanque 1', key: 'field20', width: 20 },
      { header: 'Caudal 1 Tanque 2', key: 'field13', width: 20 },
      { header: 'Caudal 2 Tanque 2', key: 'field14', width: 20 },
      { header: 'Caudal 3 Tanque 2', key: 'field21', width: 20 },
      { header: 'Caudal 1 Tanque 3', key: 'field15', width: 20 },
      { header: 'Caudal 2 Tanque 3', key: 'field16', width: 20 },
      { header: 'Caudal 3 Tanque 3', key: 'field22', width: 20 },
      { header: 'Caudal 1 Tanque 4', key: 'field26', width: 20 },
      { header: 'Caudal 2 Tanque 4', key: 'field27', width: 20 },
      { header: 'Caudal 3 Tanque 4', key: 'field28', width: 20 },
      { header: 'Nivel Tanque 1', key: 'field17', width: 15 },
      { header: 'Nivel Tanque 2', key: 'field18', width: 15 },
      { header: 'Nivel Tanque 3', key: 'field19', width: 15 },
      { header: 'Nivel Tanque 4', key: 'field25', width: 15 },
    ];
  
    // Agregar los datos a las filas del archivo de Excel
    Object.values(this.deviceHistoryMap[this.dev_reference]).forEach(device => {
      worksheet.addRow(device);
    });
  
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const start = this.convertirFechaInicioParaApi();
      const end = this.convertirFechaFinParaApi();
      if(start==end){
        saveAs(blob, this.dev_reference + "_Fecha_"+start+"_lecturas.xlsx");
      } else{
        saveAs(blob, this.dev_reference + "_Fecha_De_:"+start+"_Hasta_:"+end+"_lecturas.xlsx");
      }
    });
  }

  destroyCharts() {
    Object.values(this.charts).forEach((chart) => {
      chart.destroy();
    });
    this.charts = [];
  }

  convertirFechaInicioParaApi(): string{
    if (this.selectedDate.value.start) {
      const fecha = new Date(this.selectedDate.value.start);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "Fecha de inicio no seleccionada";
  }

  convertirFechaFinParaApi(): string{
    if (this.selectedDate.value.end) {
      const fecha = new Date(this.selectedDate.value.end);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "Fecha fin no seleccionada";
  }

  getDeviceIdFromPath(path: string): number {
    const parts = path.split('/');
    const lastPart = parts[parts.length - 1];
    const lastNumber = parseInt(lastPart, 10);
    return lastNumber;
  }

  initMap() {
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }
  
  convertirFecha(fecha: string): string {
    const fechaParseada = parseISO(fecha);
    const fechaFormateada = format(fechaParseada, "EEEE, d 'de' MMMM 'de' yyyy HH:mm", { locale: es });
    return fechaFormateada;
  }

  conseguirHoraEnFecha(fecha: string): string {
    const dateTimeString = fecha;
    const dateObj = new Date(dateTimeString);
    const hour = dateObj.getHours().toString().padStart(2, '0');
    const minute = dateObj.getMinutes().toString().padStart(2, '0');
    //const second = dateObj.getSeconds().toString().padStart(2, '0'); // Agrega ceros al principio si es necesario
    const timeString = `${hour}:${minute}`;
    return timeString;
  }

  quitarAnioYMesSiMismoAnioYMes(fechas: string[], start: string, end: string): string[] {
    const mismoAnioMesStart = start.substring(0, 7) === end.substring(0, 7);
    const mismoAnioStart = start.substring(0, 4) === end.substring(0, 4);
    if (mismoAnioMesStart) {
      if(fechas[0].length == 5){
        /*Si el start y el end es el mismo día la respuesta devuelve la fecha en 
        formato HH:MM y no hay que cambiar nada solo el titulo*/
        this.stringTitulosTiempo = "Fecha (HH:mm)";
      } else {
        this.stringTitulosTiempo = "Fecha (Día HH:mm)";
        fechas = fechas.map(fecha => fecha.substring(8));
      }
    } else if (mismoAnioStart) {
      this.stringTitulosTiempo = "Fecha (Mes-Día HH:mm)";
      fechas = fechas.map(fecha => fecha.substring(5));
    } else {
      this.stringTitulosTiempo = "Fecha (Año-Mes-Día HH:mm)";
    }
    return fechas;
  }

  calcularMajorTicks(minValue: number | null, maxValue: number | null, intervalo: number, defaultMax: number): number[] {
    let start = minValue !== null ? Math.ceil(minValue) : 0;
    let end = maxValue !== null ? maxValue + 1 : defaultMax;
  
    if (minValue !== null) {
      start -= 1;
    }
    const result: number[] = [];
    for (let i = start; i <= end; i += intervalo) {
      result.push(i);
    }
    return result;
  }

  getDevicesData(chartStart: string, chartEnd: string, timeScale: string, recargarGafica: boolean, actualizar: boolean){
    this.establishmentData = [];
    this.dispostivoData = [];
    this.hayAlarmas = false;
    this.establishmentSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next:async resp =>{
        this.establishmentData = resp;
        for(let i=0; i<this.establishmentData.length; i++){
          if (this.getDeviceIdFromPath(this.currentPath)==this.establishmentData[i].id){
            this.dispostivoData = this.establishmentData[i];
            if(this.dispostivoData.alarms.length === 0){
              this.hayAlarmas = false;
            } else {
              this.hayAlarmas = true;
            }
            /*let tanks = this.establishmentData[i].tanks;
            //let tanksData: any;
            console.log(tanks);
            for(let i=0; i<tanks.length; i++){
              console.log(tanks[i].slot);
              const tank: any ={
                condicionActivo: this.establishmentData[i].lastreader.field2,
              }
            }*/
            /***************************************************************/
            let tanks = this.establishmentData[i].tanks;
            this.alarmRangesTanks = [];
            for (let j = 0; j < tanks.length; j++) {
              const alarmRanges = JSON.parse(tanks[j].alarm_ranges);
              this.alarmRangesTanks.push({
                id: tanks[j].id,
                alarmRanges: alarmRanges,
              });
            }
            //Añadir borde verde a imagen correspondiente
            if(this.establishmentData[i].lastreader.field2=="1"){
              this.condicionT1Activo = true;
            } else{ 
              if(this.establishmentData[i].lastreader.field2=="2"){
                this.condicionT2Activo = true;
              } else {
                if(this.establishmentData[i].lastreader.field2=="3"){
                  this.condicionT3Activo = true;
                } else {
                  if(this.establishmentData[i].lastreader.field2=="4"){
                    this.condicionT4Activo = true;
                  }
                }
              }
            }
            /*if(options.t1 == true){
              this.verT1 = true;
            } 
            if(options.t2 == true){
              this.verT2 = true;
            } 
            if(options.t3 == true){
              this.verT3 = true;
            }*/
            let urlMapTmp = this.urlBase + '/GIS/index.php?devices=' + this.establishmentData[i].id;
            this.urlMap = this.sanitizer.bypassSecurityTrustResourceUrl(urlMapTmp);
            //Refenrencia del dispositivo
            this.dev_reference = this.establishmentData[i].dev_reference;
            await this.calcularConsumoDiaActual(this.dev_reference);
            //GRÁFICOS DE CONSULTA DE HISTÓRICOS LA PRIMERA VEZ
            if(recargarGafica && !actualizar){
              const fechaOriginal = new Date(this.fechaFormateada);
              const fechaSumada = new Date(fechaOriginal);
              fechaSumada.setDate(fechaOriginal.getDate() + 1);
              this.loadTodayCharts(this.dev_reference, chartStart, chartEnd, timeScale);
              console.log(this.litrosConsumidosPorTanque);
            }
            //HACER UN PUSH AL DATASET DE LAS GRÁFICAS SI SON DEL DIA DE HOY Y ESTAMOS DENTRO DEL INTERVAL
            if(recargarGafica && actualizar){
              const fechaOriginal = new Date(this.fechaFormateada);
              const fechaSumada = new Date(fechaOriginal);
              fechaSumada.setDate(fechaOriginal.getDate() + 1);
              this.actualizarTodayCharts(this.dev_reference, chartStart, chartEnd, timeScale);
            }
            if(this.establishmentData[i].dev_status="1"){
              this.activado = true;
            }
            this.dev_id = this.establishmentData[i].id;
            this.dev_label = this.establishmentData[i].dev_label;
            this.dev_create_at = this.establishmentData[i].dev_create_at;
            //this.dev_img = this.establishmentData[i].dev_imgs;
            this.dev_img = this.establishmentData[i].dev_imgs;      
            this.tanksInfo = [];
            for(let i=0; i<tanks.length; i++){
              this.tanksInfo.push({
                tipoCerveza: tanks[i].beer_type_id,
                imagenCerveza: tanks[i].beertype.img,
                imagenCervezaURL: this.urlBase +'/uploads/imgs/'+ tanks[i].beertype.img,
                capacidad: tanks[i].capacity,
                numeroTanque: tanks[i].custom_num,
                recargaNecesaria: this.existeAlarmaConTypeSymbol("L" + tanks[i].custom_num),
                establishment_id: this.establishmentData[i].dev_est_id,
                tank_id: tanks[i].id,
              });
              if(i==0 && tanks[i]){
                this.verT1 = true;
                this.tipoCervezaT1 = tanks[i].beer_type_id;
                this.imagenCervezaT1 = tanks[i].beertype.img;
                this.imagenCervezaT1Url = this.urlBase +'/uploads/imgs/'+ tanks[i].beertype.img;
                this.capacidadT1 = tanks[i].capacity;
                this.numeroTanque1 = tanks[i].custom_num;
              }
              if(i==1 && tanks[i]){
                this.verT2 = true;
                this.tipoCervezaT2 = tanks[i].beer_type_id;
                this.imagenCervezaT2 = tanks[i].beertype.img;
                this.imagenCervezaT2Url = this.urlBase +'/uploads/imgs/'+ tanks[i].beertype.img;
                this.capacidadT2 = tanks[i].capacity;
                this.numeroTanque2 = tanks[i].custom_num;
              }
              if(i==2 && tanks[i]){
                this.verT3 = true;
                this.tipoCervezaT3 = tanks[i].beer_type_id;
                this.imagenCervezaT3 = tanks[i].beertype.img;
                this.imagenCervezaT3Url = this.urlBase +'/uploads/imgs/'+ tanks[i].beertype.img;
                this.capacidadT3 = tanks[i].capacity;
                this.numeroTanque3 = tanks[i].custom_num;
              }
              if(i==3 && tanks[i]){
                this.verT4 = true;
                this.tipoCervezaT4 = tanks[i].beer_type_id;
                this.imagenCervezaT4 = tanks[i].beertype.img;
                this.imagenCervezaT4Url = this.urlBase +'/uploads/imgs/'+ tanks[i].beertype.img;
                this.capacidadT4 = tanks[i].capacity;
                this.numeroTanque4 = tanks[i].custom_num;
              }
            }

            /*this.tipoCervezaT1 = options.beertype1;
            this.tipoCervezaT2 = options.beertype2;
            this.tipoCervezaT3 = options.beertype3;
            this.capacidadT1 = options.cap1;
            this.capacidadT2 = options.cap2;
            this.capacidadT3 = options.cap3;*/
            if(this.establishmentData[i].lastreader.created_at == null){
              this.fechaDelUltimoHistorico = "No hay datos registrados todavía";
            } else {
              this.fechaDelUltimoHistorico = this.convertirFecha(this.establishmentData[i].lastreader.created_at);
            }
            this.temperaturaAmbiente = this.establishmentData[i].lastreader.field9;
            this.temperaturaT1 = parseFloat(this.establishmentData[i].lastreader.field6).toFixed(1);
            this.temperaturaT2 = parseFloat(this.establishmentData[i].lastreader.field7).toFixed(1);
            this.temperaturaT3 = parseFloat(this.establishmentData[i].lastreader.field8).toFixed(1);
            this.temperaturaT4 = parseFloat(this.establishmentData[i].lastreader.field24).toFixed(1);
            this.presionT1 = parseFloat(this.establishmentData[i].lastreader.field3).toFixed(1);
            this.presionT2 = parseFloat(this.establishmentData[i].lastreader.field4).toFixed(1);
            this.presionT3 = parseFloat(this.establishmentData[i].lastreader.field5).toFixed(1);
            this.presionT4 = parseFloat(this.establishmentData[i].lastreader.field23).toFixed(1);
            this.nivelT1 = ((parseFloat(this.establishmentData[i].lastreader.field17)*100)/parseInt(this.capacidadT1)).toFixed(1);
            this.nivelT2 = ((parseFloat(this.establishmentData[i].lastreader.field18)*100)/parseInt(this.capacidadT2)).toFixed(1);
            this.nivelT3 = ((parseFloat(this.establishmentData[i].lastreader.field19)*100)/parseInt(this.capacidadT3)).toFixed(1);
            this.nivelT4 = ((parseFloat(this.establishmentData[i].lastreader.field25)*100)/parseInt(this.capacidadT4)).toFixed(1);
            this.consumidosT1 = (parseInt(this.capacidadT1) - ((parseInt(this.nivelT1) * parseInt(this.capacidadT1))/100)).toFixed(1);
            this.consumidosT2 = (parseInt(this.capacidadT2) - ((parseInt(this.nivelT2) * parseInt(this.capacidadT2))/100)).toFixed(1);
            this.consumidosT3 = (parseInt(this.capacidadT3) - ((parseInt(this.nivelT3) * parseInt(this.capacidadT3))/100)).toFixed(1);
            this.consumidosT4 = (parseInt(this.capacidadT4) - ((parseInt(this.nivelT4) * parseInt(this.capacidadT4))/100)).toFixed(1);

            const soloDosDecimalesConComa = (cadena: string) => {
              let numero;
              numero = parseFloat(cadena);
              if(Number.isNaN(numero)){
                return "--"
              } else {
                return numero.toLocaleString(this.userServiceData.region, { maximumFractionDigits: 2 });
              }
            };

            //CONVERTIR EL NÚMERO DEPENDIENDO DE LA REGION
            this.temperaturaAmbiente = soloDosDecimalesConComa(this.temperaturaAmbiente);
            this.temperaturaT1 = soloDosDecimalesConComa(this.temperaturaT1);
            this.temperaturaT2 = soloDosDecimalesConComa(this.temperaturaT2);
            this.temperaturaT3 = soloDosDecimalesConComa(this.temperaturaT3);
            this.temperaturaT4 = soloDosDecimalesConComa(this.temperaturaT4);
            this.presionT1 = soloDosDecimalesConComa(this.presionT1);
            this.presionT2 = soloDosDecimalesConComa(this.presionT2);
            this.presionT3 = soloDosDecimalesConComa(this.presionT3);
            this.presionT4 = soloDosDecimalesConComa(this.presionT4);
            this.nivelT1 = soloDosDecimalesConComa(this.nivelT1);
            this.nivelT2 = soloDosDecimalesConComa(this.nivelT2);
            this.nivelT3 = soloDosDecimalesConComa(this.nivelT3);
            this.nivelT4 = soloDosDecimalesConComa(this.nivelT4);
            this.consumidosT1 = soloDosDecimalesConComa(this.consumidosT1);
            this.consumidosT2 = soloDosDecimalesConComa(this.consumidosT2);
            this.consumidosT3 = soloDosDecimalesConComa(this.consumidosT3);
            this.consumidosT4 = soloDosDecimalesConComa(this.consumidosT4);
          }
        }
        //this.datosRecibidos1 = true;
      /******************************************Tanque 1**************************************************/
        if(recargarGafica && !actualizar){
          setTimeout(() => {
            if(this.verT1 == true){
              let alarmaNivelT1 = this.alarmRangesTanks[0].alarmRanges.beerLevelMin ?? 0;
              let alarmaTemeraturaMinT1 = this.alarmRangesTanks[0].alarmRanges.beerTemperatureMin;
              let alarmaTemeraturaMaxT1 = this.alarmRangesTanks[0].alarmRanges.beerTemperatureMax;
              let alarmaPresionMinT1 = this.alarmRangesTanks[0].alarmRanges.beerPressureMin;
              let alarmaPresionMaxT1 = this.alarmRangesTanks[0].alarmRanges.beerPressureMax;
              /*if(alarmaTemeraturaMinT1 < 0 || alarmaTemeraturaMinT1 > 10){
                alarmaTemeraturaMinT1 = null;
              }
              if(alarmaTemeraturaMaxT1 < 0 || alarmaTemeraturaMaxT1 > 10){
                alarmaTemeraturaMaxT1 = null;
              } 
              if(alarmaPresionMinT1 < 0 || alarmaPresionMinT1 > 6){
                alarmaPresionMinT1 = null;
              } 
              if(alarmaPresionMaxT1 < 0 || alarmaPresionMaxT1 > 6){
                alarmaPresionMaxT1 = null;
              }*/
              this.gaugeNivel1 = new RadialGauge({
                renderTo: 'nivelTanque1',
                width: 160,
                height: 600,
                units: "%",
                fontUnitsSize: 40,
                minValue: 0,
                maxValue: 100,
                majorTicks: [0,20,40,60,80,100],
                minorTicks: 2,
                valueBox: false,
                highlights: [
                  {
                    "from": alarmaNivelT1,
                    "to": 100,
                    "color": "rgba(0, 255, 0, 1)"
                  },
                  {
                    "from": 0,
                    "to": alarmaNivelT1,
                    "color": "#B00B1F"
                  }
                ]
              }).draw();
              this.gaugeNivel1.value = parseInt(this.nivelT1);
              //gaugenivel1.value = parseInt(this.temperaturaT1);
              //console.log(this.calcularMajorTicks(alarmaTemeraturaMinT1, alarmaTemeraturaMaxT1, 1));
              const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT1, alarmaTemeraturaMaxT1, 1, 10);
              if(alarmaTemeraturaMinT1 == null){
                alarmaTemeraturaMinT1 = 0
              }
              if(alarmaTemeraturaMaxT1 == null){
                alarmaTemeraturaMaxT1 = 10
              }
              this.gaugeTemperatura1 = new RadialGauge({
                renderTo: 'temperaturaTanque1',
                width: 160,
                height: 600,
                units: "ºC",
                fontUnitsSize: 40,
                minValue: ticksformateados[0],
                maxValue: ticksformateados[ticksformateados.length - 1],
                majorTicks: ticksformateados,
                minorTicks: 2,
                valueBox: false,
                highlights: [
                  {
                    "from": ticksformateados[0],
                    "to": alarmaTemeraturaMinT1,
                    "color": "#B00B1F"
                  },
                  {
                    "from": alarmaTemeraturaMinT1,
                    "to": alarmaTemeraturaMaxT1,
                    "color": "rgba(0, 255, 0, 1)"
                  },
                  {
                    "from": alarmaTemeraturaMaxT1,
                    "to": ticksformateados[ticksformateados.length - 1],
                    "color": "#B00B1F"
                  }
                ]
              }).draw();
              this.gaugeTemperatura1.value = parseInt(this.temperaturaT1);

              const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT1, alarmaPresionMaxT1, 1, 6);
              if(alarmaPresionMinT1 == null){
                alarmaPresionMinT1 = 0
              }
              if(alarmaPresionMaxT1 == null){
                alarmaPresionMaxT1 = 6
              }
              this.gaugePresion1 = new RadialGauge({
                renderTo: 'presionTanque1',
                width: 160,
                height: 600,
                units: "Bar",
                fontUnitsSize: 35,
                minValue: ticksformateadosP[0],
                maxValue: ticksformateadosP[ticksformateadosP.length - 1],
                majorTicks: ticksformateadosP,
                minorTicks: 2,
                valueBox: false,
                highlights: [
                  {
                    "from": ticksformateadosP[0],
                    "to": alarmaPresionMinT1,
                    "color": "#B00B1F"
                  },
                  {
                    "from": alarmaPresionMinT1,
                    "to": alarmaPresionMaxT1,
                    "color": "rgba(0, 255, 0, 1)"
                  },
                  {
                    "from": alarmaPresionMaxT1,
                    "to": ticksformateadosP[ticksformateadosP.length - 1],
                    "color": "#B00B1F"
                  }
                ]
              }).draw();
              this.gaugePresion1.value = parseInt(this.presionT1);
            }
          /******************************************Tanque 2**************************************************/
            if(this.verT2 == true){
              let alarmaNivelT = this.alarmRangesTanks[1].alarmRanges.beerLevelMin ?? 0;
              let alarmaTemeraturaMinT = this.alarmRangesTanks[1].alarmRanges.beerTemperatureMin;
              let alarmaTemeraturaMaxT = this.alarmRangesTanks[1].alarmRanges.beerTemperatureMax;
              let alarmaPresionMinT = this.alarmRangesTanks[1].alarmRanges.beerPressureMin;
              let alarmaPresionMaxT = this.alarmRangesTanks[1].alarmRanges.beerPressureMax;

              this.gaugeNivel2 = new RadialGauge({
                renderTo: 'nivelTanque2',
                width: 160,
                height: 600,
                units: "%",
                fontUnitsSize: 40,
                minValue: 0,
                maxValue: 100,
                majorTicks: [0,20,40,60,80,100],
                minorTicks: 2,
                valueBox: false,
                highlights: [
                  {
                    "from": alarmaNivelT,
                    "to": 100,
                    "color": "rgba(0, 255, 0, 1)"
                  },
                  {
                    "from": 0,
                    "to": alarmaNivelT,
                    "color": "#B00B1F"
                  }
                ]
              }).draw();
              this.gaugeNivel2.value = parseInt(this.nivelT2);

              const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT, alarmaTemeraturaMaxT, 1, 10);
              if(alarmaTemeraturaMinT == null){
                alarmaTemeraturaMinT = 0
              }
              if(alarmaTemeraturaMaxT == null){
                alarmaTemeraturaMaxT = 10
              }
              this.gaugeTemperatura2 = new RadialGauge({
                renderTo: 'temperaturaTanque2',
                width: 160,
                height: 600,
                units: "ºC",
                fontUnitsSize: 40,
                minValue: ticksformateados[0],
                maxValue: ticksformateados[ticksformateados.length - 1],
                majorTicks: ticksformateados,
                minorTicks: 2,
                valueBox: false,
                highlights: [
                  {
                    "from": ticksformateados[0],
                    "to": alarmaTemeraturaMinT,
                    "color": "#B00B1F"
                  },
                  {
                    "from": alarmaTemeraturaMinT,
                    "to": alarmaTemeraturaMaxT,
                    "color": "rgba(0, 255, 0, 1)"
                  },
                  {
                    "from": alarmaTemeraturaMaxT,
                    "to": ticksformateados[ticksformateados.length - 1],
                    "color": "#B00B1F"
                  }
                ]
              }).draw();
              this.gaugeTemperatura2.value = parseInt(this.temperaturaT2);

              const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT, alarmaPresionMaxT, 1, 6);
              if(alarmaPresionMinT == null){
                alarmaPresionMinT = 0
              }
              if(alarmaPresionMaxT == null){
                alarmaPresionMaxT = 6
              }
              this.gaugePresion2 = new RadialGauge({
                renderTo: 'presionTanque2',
                width: 160,
                height: 600,
                units: "Bar",
                fontUnitsSize: 35,
                minValue: ticksformateadosP[0],
                maxValue: ticksformateadosP[ticksformateadosP.length - 1],
                majorTicks: ticksformateadosP,
                minorTicks: 2,
                valueBox: false,
                highlights: [
                  {
                    "from": ticksformateadosP[0],
                    "to": alarmaPresionMinT,
                    "color": "#B00B1F"
                  },
                  {
                    "from": alarmaPresionMinT,
                    "to": alarmaPresionMaxT,
                    "color": "rgba(0, 255, 0, 1)"
                  },
                  {
                    "from": alarmaPresionMaxT,
                    "to": ticksformateadosP[ticksformateadosP.length - 1],
                    "color": "#B00B1F"
                  }
                ]
              }).draw();
              this.gaugePresion2.value = parseInt(this.presionT2);
            }
          /******************************************Tanque 3**************************************************/
          if(this.verT3 == true){
            let alarmaNivelT = this.alarmRangesTanks[2].alarmRanges.beerLevelMin ?? 0;
            let alarmaTemeraturaMinT = this.alarmRangesTanks[2].alarmRanges.beerTemperatureMin;
            let alarmaTemeraturaMaxT = this.alarmRangesTanks[2].alarmRanges.beerTemperatureMax;
            let alarmaPresionMinT = this.alarmRangesTanks[2].alarmRanges.beerPressureMin;
            let alarmaPresionMaxT = this.alarmRangesTanks[2].alarmRanges.beerPressureMax;

            this.gaugeNivel3 = new RadialGauge({
              renderTo: 'nivelTanque3',
              width: 160,
              height: 600,
              units: "%",
              fontUnitsSize: 40,
              minValue: 0,
              maxValue: 100,
              majorTicks: [0,20,40,60,80,100],
              minorTicks: 2,
              valueBox: false,
              highlights: [
                {
                  "from": alarmaNivelT,
                  "to": 100,
                  "color": "rgba(0, 255, 0, 1)"
                },
                {
                  "from": 0,
                  "to": alarmaNivelT,
                  "color": "#B00B1F"
                }
              ]
            }).draw();
            this.gaugeNivel3.value = parseInt(this.nivelT3);

            const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT, alarmaTemeraturaMaxT, 1, 10);
            if(alarmaTemeraturaMinT == null){
              alarmaTemeraturaMinT = 0
            }
            if(alarmaTemeraturaMaxT == null){
              alarmaTemeraturaMaxT = 10
            }
            this.gaugeTemperatura3 = new RadialGauge({
              renderTo: 'temperaturaTanque3',
              width: 160,
              height: 600,
              units: "ºC",
              fontUnitsSize: 40,
              minValue: ticksformateados[0],
              maxValue: ticksformateados[ticksformateados.length - 1],
              majorTicks: ticksformateados,
              minorTicks: 2,
              valueBox: false,
              highlights: [
                {
                  "from": ticksformateados[0],
                  "to": alarmaTemeraturaMinT,
                  "color": "#B00B1F"
                },
                {
                  "from": alarmaTemeraturaMinT,
                  "to": alarmaTemeraturaMaxT,
                  "color": "rgba(0, 255, 0, 1)"
                },
                {
                  "from": alarmaTemeraturaMaxT,
                  "to": ticksformateados[ticksformateados.length - 1],
                  "color": "#B00B1F"
                }
              ]
            }).draw();
            this.gaugeTemperatura3.value = parseInt(this.temperaturaT3);

            const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT, alarmaPresionMaxT, 1, 6);
            if(alarmaPresionMinT == null){
              alarmaPresionMinT = 0
            }
            if(alarmaPresionMaxT == null){
              alarmaPresionMaxT = 6
            }
            this.gaugePresion3 = new RadialGauge({
              renderTo: 'presionTanque3',
              width: 160,
              height: 600,
              units: "Bar",
              fontUnitsSize: 35,
              minValue: ticksformateadosP[0],
              maxValue: ticksformateadosP[ticksformateadosP.length - 1],
              majorTicks: ticksformateadosP,
              minorTicks: 2,
              valueBox: false,
              highlights: [
                {
                  "from": ticksformateadosP[0],
                  "to": alarmaPresionMinT,
                  "color": "#B00B1F"
                },
                {
                  "from": alarmaPresionMinT,
                  "to": alarmaPresionMaxT,
                  "color": "rgba(0, 255, 0, 1)"
                },
                {
                  "from": alarmaPresionMaxT,
                  "to": ticksformateadosP[ticksformateadosP.length - 1],
                  "color": "#B00B1F"
                }
              ]
            }).draw();
            this.gaugePresion3.value = parseInt(this.presionT3);
          }
          /******************************************Tanque 4**************************************************/
          if(this.verT4 == true){
            let alarmaNivelT = this.alarmRangesTanks[3].beerLevelMin ?? 0;
            let alarmaTemeraturaMinT = this.alarmRangesTanks[3].alarmRanges.beerTemperatureMin;
            let alarmaTemeraturaMaxT = this.alarmRangesTanks[3].alarmRanges.beerTemperatureMax;
            let alarmaPresionMinT = this.alarmRangesTanks[3].alarmRanges.beerPressureMin;
            let alarmaPresionMaxT = this.alarmRangesTanks[3].alarmRanges.beerPressureMax;
            if(alarmaTemeraturaMinT < 0 || alarmaTemeraturaMinT > 10){
              alarmaTemeraturaMinT = null;
            } 
            if(alarmaTemeraturaMaxT < 0 || alarmaTemeraturaMaxT > 10){
              alarmaTemeraturaMaxT = null;
            } 
            if(alarmaPresionMinT < 0 || alarmaPresionMinT > 6){
              alarmaPresionMinT = null;
            } 
            if(alarmaPresionMaxT < 0 || alarmaPresionMaxT > 6){
              alarmaPresionMaxT = null;
            } 
            this.gaugeNivel4 = new RadialGauge({
              renderTo: 'nivelTanque4',
              width: 160,
              height: 600,
              units: "%",
              fontUnitsSize: 40,
              minValue: 0,
              maxValue: 100,
              majorTicks: [0,20,40,60,80,100],
              minorTicks: 2,
              valueBox: false,
              highlights: [
                {
                  "from": alarmaNivelT,
                  "to": 100,
                  "color": "rgba(0, 255, 0, 1)"
                },
                {
                  "from": 0,
                  "to": alarmaNivelT,
                  "color": "#B00B1F"
                }
              ]
            }).draw();
            this.gaugeNivel4.value = parseInt(this.nivelT4);

            const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT, alarmaTemeraturaMaxT, 1, 10);
            if(alarmaTemeraturaMinT == null){
              alarmaTemeraturaMinT = 0
            }
            if(alarmaTemeraturaMaxT == null){
              alarmaTemeraturaMaxT = 10
            }
            this.gaugeTemperatura4 = new RadialGauge({
              renderTo: 'temperaturaTanque4',
              width: 160,
              height: 600,
              units: "ºC",
              fontUnitsSize: 40,
              minValue: ticksformateados[0],
              maxValue: ticksformateados[ticksformateados.length - 1],
              majorTicks: ticksformateados,
              minorTicks: 2,
              valueBox: false,
              highlights: [
                {
                  "from": ticksformateados[0],
                  "to": alarmaTemeraturaMinT,
                  "color": "#B00B1F"
                },
                {
                  "from": alarmaTemeraturaMinT,
                  "to": alarmaTemeraturaMaxT,
                  "color": "rgba(0, 255, 0, 1)"
                },
                {
                  "from": alarmaTemeraturaMaxT,
                  "to": ticksformateados[ticksformateados.length - 1],
                  "color": "#B00B1F"
                }
              ]
            }).draw();
            this.gaugeTemperatura4.value = parseInt(this.temperaturaT4);
            
            const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT, alarmaPresionMaxT, 1, 6);
            if(alarmaPresionMinT == null){
              alarmaPresionMinT = 0
            }
            if(alarmaPresionMaxT == null){
              alarmaPresionMaxT = 6
            }
            this.gaugePresion4 = new RadialGauge({
              renderTo: 'presionTanque4',
              width: 160,
              height: 600,
              units: "Bar",
              fontUnitsSize: 35,
              minValue: ticksformateadosP[0],
              maxValue: ticksformateadosP[ticksformateadosP.length - 1],
              majorTicks: ticksformateadosP,
              minorTicks: 2,
              valueBox: false,
              highlights: [
                {
                  "from": ticksformateadosP[0],
                  "to": alarmaPresionMinT,
                  "color": "#B00B1F"
                },
                {
                  "from": alarmaPresionMinT,
                  "to": alarmaPresionMaxT,
                  "color": "rgba(0, 255, 0, 1)"
                },
                {
                  "from": alarmaPresionMaxT,
                  "to": ticksformateadosP[ticksformateadosP.length - 1],
                  "color": "#B00B1F"
                }
              ]
            }).draw();
            this.gaugePresion4.value = parseInt(this.presionT4);
          }
          this.gaugesCargados = true;
        }, 0);
      }

      if(recargarGafica && actualizar){
        //Actualizar solo los valores y el valor de las alarmas 
        let highlightsNivel: Array<{
          from: number;
          to: number;
          color: string;
        }> = [];
        let highlightsTermperatura: Array<{
          from: number;
          to: number;
          color: string;
        }> = [];
        let highlightsPresion: Array<{
          from: number;
          to: number;
          color: string;
        }> = [];
        if(this.verT1 == true){
          //Alarmas
            let alarmaNivelT = this.alarmRangesTanks[0].alarmRanges.beerLevelMin ?? 0;
            let alarmaTemeraturaMinT = this.alarmRangesTanks[0].alarmRanges.beerTemperatureMin;
            let alarmaTemeraturaMaxT = this.alarmRangesTanks[0].alarmRanges.beerTemperatureMax;
            let alarmaPresionMinT = this.alarmRangesTanks[0].alarmRanges.beerPressureMin;
            let alarmaPresionMaxT = this.alarmRangesTanks[0].alarmRanges.beerPressureMax; 
          //Nivel 
            highlightsNivel = [
              {
                "from": alarmaNivelT,
                "to": 100,
                "color": "rgba(0, 255, 0, 1)"
              },
              {
                "from": 0,
                "to": alarmaNivelT,
                "color": "#B00B1F"
              }
            ];
            this.gaugeNivel1.options.highlights = highlightsNivel;
            this.gaugeNivel1.value = parseInt(this.nivelT1);
            this.gaugeNivel1.update();
          //Temperatura 
            const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT, alarmaTemeraturaMaxT, 1, 10);
            if(alarmaTemeraturaMinT == null){
              alarmaTemeraturaMinT = 0
            }
            if(alarmaTemeraturaMaxT == null){
              alarmaTemeraturaMaxT = 10
            }
            highlightsTermperatura = [
              {
                "from": ticksformateados[0],
                "to": alarmaTemeraturaMinT,
                "color": "#B00B1F"
              },
              {
                "from": alarmaTemeraturaMinT,
                "to": alarmaTemeraturaMaxT,
                "color": "rgba(0, 255, 0, 1)"
              },
              {
                "from": alarmaTemeraturaMaxT,
                "to": ticksformateados[ticksformateados.length - 1],
                "color": "#B00B1F"
              }
            ]
            this.gaugeTemperatura1.options.highlights = highlightsTermperatura;
            this.gaugeTemperatura1.options.minValue = ticksformateados[0];
            this.gaugeTemperatura1.options.maxValue = ticksformateados[ticksformateados.length - 1];
            this.gaugeTemperatura1.options.majorTicks = ticksformateados;
            this.gaugeTemperatura1.value = parseInt(this.temperaturaT1);
            this.gaugeTemperatura1.update();
          //Presion 
            const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT, alarmaPresionMaxT, 1, 6);
            if(alarmaPresionMinT == null){
              alarmaPresionMinT = 0
            }
            if(alarmaPresionMaxT == null){
              alarmaPresionMaxT = 6
            }
            highlightsPresion = [
              {
                "from": ticksformateadosP[0],
                "to": alarmaPresionMinT,
                "color": "#B00B1F"
              },
              {
                "from": alarmaPresionMinT,
                "to": alarmaPresionMaxT,
                "color": "rgba(0, 255, 0, 1)"
              },
              {
                "from": alarmaPresionMaxT,
                "to": ticksformateadosP[ticksformateadosP.length - 1],
                "color": "#B00B1F"
              }
            ]
            this.gaugePresion1.options.highlights = highlightsPresion;
            this.gaugePresion1.options.minValue = ticksformateadosP[0];
            this.gaugePresion1.options.maxValue = ticksformateadosP[ticksformateadosP.length - 1];
            this.gaugePresion1.options.majorTicks = ticksformateadosP;
            this.gaugePresion1.value = parseInt(this.presionT1);
            this.gaugePresion1.update();
        }
        if(this.verT2 == true){
          //Alarmas
          let alarmaNivelT = this.alarmRangesTanks[1].alarmRanges.beerLevelMin ?? 0;
          let alarmaTemeraturaMinT = this.alarmRangesTanks[1].alarmRanges.beerTemperatureMin;
          let alarmaTemeraturaMaxT = this.alarmRangesTanks[1].alarmRanges.beerTemperatureMax;
          let alarmaPresionMinT = this.alarmRangesTanks[1].alarmRanges.beerPressureMin;
          let alarmaPresionMaxT = this.alarmRangesTanks[1].alarmRanges.beerPressureMax;
        //Nivel 
          highlightsNivel = [
            {
              "from": alarmaNivelT,
              "to": 100,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": 0,
              "to": alarmaNivelT,
              "color": "#B00B1F"
            }
          ];
          this.gaugeNivel2.options.highlights = highlightsNivel;
          this.gaugeNivel2.value = parseInt(this.nivelT2);
          this.gaugeNivel2.update();
        //Temperatura 
          const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT, alarmaTemeraturaMaxT, 1, 10);
          if(alarmaTemeraturaMinT == null){
            alarmaTemeraturaMinT = 0
          }
          if(alarmaTemeraturaMaxT == null){
            alarmaTemeraturaMaxT = 10
          }
          highlightsTermperatura = [
            {
              "from": ticksformateados[0],
              "to": alarmaTemeraturaMinT,
              "color": "#B00B1F"
            },
            {
              "from": alarmaTemeraturaMinT,
              "to": alarmaTemeraturaMaxT,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": alarmaTemeraturaMaxT,
              "to": ticksformateados[ticksformateados.length - 1],
              "color": "#B00B1F"
            }
          ]
          this.gaugeTemperatura2.options.highlights = highlightsTermperatura;
          this.gaugeTemperatura2.options.minValue = ticksformateados[0];
          this.gaugeTemperatura2.options.maxValue = ticksformateados[ticksformateados.length - 1];
          this.gaugeTemperatura2.options.majorTicks = ticksformateados;
          this.gaugeTemperatura2.value = parseInt(this.temperaturaT2);
          this.gaugeTemperatura2.update();
        //Presion 
          const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT, alarmaPresionMaxT, 1, 6);
          if(alarmaPresionMinT == null){
            alarmaPresionMinT = 0
          }
          if(alarmaPresionMaxT == null){
            alarmaPresionMaxT = 6
          }
          highlightsPresion = [
            {
              "from": ticksformateadosP[0],
              "to": alarmaPresionMinT,
              "color": "#B00B1F"
            },
            {
              "from": alarmaPresionMinT,
              "to": alarmaPresionMaxT,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": alarmaPresionMaxT,
              "to": ticksformateadosP[ticksformateadosP.length - 1],
              "color": "#B00B1F"
            }
          ]
          this.gaugePresion2.options.highlights = highlightsPresion;
          this.gaugePresion2.options.minValue = ticksformateadosP[0];
          this.gaugePresion2.options.maxValue = ticksformateadosP[ticksformateadosP.length - 1];
          this.gaugePresion2.options.majorTicks = ticksformateadosP;
          this.gaugePresion2.value = parseInt(this.presionT2);
          this.gaugePresion2.update();
        }
        if(this.verT3 == true){
          //Alarmas
          let alarmaNivelT = this.alarmRangesTanks[2].alarmRanges.beerLevelMin ?? 0;
          let alarmaTemeraturaMinT = this.alarmRangesTanks[2].alarmRanges.beerTemperatureMin;
          let alarmaTemeraturaMaxT = this.alarmRangesTanks[2].alarmRanges.beerTemperatureMax;
          let alarmaPresionMinT = this.alarmRangesTanks[2].alarmRanges.beerPressureMin;
          let alarmaPresionMaxT = this.alarmRangesTanks[2].alarmRanges.beerPressureMax;
        //Nivel
          highlightsNivel = [
            {
              "from": alarmaNivelT,
              "to": 100,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": 0,
              "to": alarmaNivelT,
              "color": "#B00B1F"
            }
          ];
          this.gaugeNivel3.options.highlights = highlightsNivel;
          this.gaugeNivel3.value = parseInt(this.nivelT3);
          this.gaugeNivel3.update();
        //Temperatura
          const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT, alarmaTemeraturaMaxT, 1, 10);
          if(alarmaTemeraturaMinT == null){
            alarmaTemeraturaMinT = 0
          }
          if(alarmaTemeraturaMaxT == null){
            alarmaTemeraturaMaxT = 10
          }
          highlightsTermperatura = [
            {
              "from": ticksformateados[0],
              "to": alarmaTemeraturaMinT,
              "color": "#B00B1F"
            },
            {
              "from": alarmaTemeraturaMinT,
              "to": alarmaTemeraturaMaxT,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": alarmaTemeraturaMaxT,
              "to": ticksformateados[ticksformateados.length - 1],
              "color": "#B00B1F"
            }
          ]
          this.gaugeTemperatura3.options.highlights = highlightsTermperatura;
          this.gaugeTemperatura3.options.minValue = ticksformateados[0];
          this.gaugeTemperatura3.options.maxValue = ticksformateados[ticksformateados.length - 1];
          this.gaugeTemperatura3.options.majorTicks = ticksformateados;
          this.gaugeTemperatura3.value = parseInt(this.temperaturaT3);
          this.gaugeTemperatura3.update();
        //Presion
          const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT, alarmaPresionMaxT, 1, 6);
          if(alarmaPresionMinT == null){
            alarmaPresionMinT = 0
          }
          if(alarmaPresionMaxT == null){
            alarmaPresionMaxT = 6
          }
          highlightsPresion = [
            {
              "from": ticksformateadosP[0],
              "to": alarmaPresionMinT,
              "color": "#B00B1F"
            },
            {
              "from": alarmaPresionMinT,
              "to": alarmaPresionMaxT,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": alarmaPresionMaxT,
              "to": ticksformateadosP[ticksformateadosP.length - 1],
              "color": "#B00B1F"
            }
          ]
          this.gaugePresion3.options.highlights = highlightsPresion;
          this.gaugePresion3.options.minValue = ticksformateadosP[0];
          this.gaugePresion3.options.maxValue = ticksformateadosP[ticksformateadosP.length - 1];
          this.gaugePresion3.options.majorTicks = ticksformateadosP;
          this.gaugePresion3.value = parseInt(this.presionT3);
          this.gaugePresion3.update();
        }
        if(this.verT4 == true){
          //Alarmas
          let alarmaNivelT = this.alarmRangesTanks[3].alarmRanges.beerLevelMin ?? 0;
          let alarmaTemeraturaMinT = this.alarmRangesTanks[3].alarmRanges.beerTemperatureMin;
          let alarmaTemeraturaMaxT = this.alarmRangesTanks[3].alarmRanges.beerTemperatureMax;
          let alarmaPresionMinT = this.alarmRangesTanks[3].alarmRanges.beerPressureMin;
          let alarmaPresionMaxT = this.alarmRangesTanks[3].alarmRanges.beerPressureMax;
        //Nivel 
          highlightsNivel = [
            {
              "from": alarmaNivelT,
              "to": 100,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": 0,
              "to": alarmaNivelT,
              "color": "#B00B1F"
            }
          ];
          this.gaugeNivel4.options.highlights = highlightsNivel;
          this.gaugeNivel4.value = parseInt(this.nivelT4);
          this.gaugeNivel4.update();
        //Temperatura 
          const ticksformateados = this.calcularMajorTicks(alarmaTemeraturaMinT, alarmaTemeraturaMaxT, 1, 10);
          if(alarmaTemeraturaMinT == null){
            alarmaTemeraturaMinT = 0
          }
          if(alarmaTemeraturaMaxT == null){
            alarmaTemeraturaMaxT = 10
          }
          highlightsTermperatura = [
            {
              "from": ticksformateados[0],
              "to": alarmaTemeraturaMinT,
              "color": "#B00B1F"
            },
            {
              "from": alarmaTemeraturaMinT,
              "to": alarmaTemeraturaMaxT,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": alarmaTemeraturaMaxT,
              "to": ticksformateados[ticksformateados.length - 1],
              "color": "#B00B1F"
            }
          ]
          this.gaugeTemperatura4.options.highlights = highlightsTermperatura;
          this.gaugeTemperatura4.options.minValue = ticksformateados[0];
          this.gaugeTemperatura4.options.maxValue = ticksformateados[ticksformateados.length - 1];
          this.gaugeTemperatura4.options.majorTicks = ticksformateados;
          this.gaugeTemperatura4.value = parseInt(this.temperaturaT4);
          this.gaugeTemperatura4.update();
        //Presion 
          const ticksformateadosP = this.calcularMajorTicks(alarmaPresionMinT, alarmaPresionMaxT, 1, 6);
          if(alarmaPresionMinT == null){
            alarmaPresionMinT = 0
          }
          if(alarmaPresionMaxT == null){
            alarmaPresionMaxT = 6
          }
          highlightsPresion = [
            {
              "from": ticksformateadosP[0],
              "to": alarmaPresionMinT,
              "color": "#B00B1F"
            },
            {
              "from": alarmaPresionMinT,
              "to": alarmaPresionMaxT,
              "color": "rgba(0, 255, 0, 1)"
            },
            {
              "from": alarmaPresionMaxT,
              "to": ticksformateadosP[ticksformateadosP.length - 1],
              "color": "#B00B1F"
            }
          ]
          this.gaugePresion4.options.highlights = highlightsPresion;
          this.gaugePresion4.options.minValue = ticksformateadosP[0];
          this.gaugePresion4.options.maxValue = ticksformateadosP[ticksformateadosP.length - 1];
          this.gaugePresion4.options.majorTicks = ticksformateadosP;
          this.gaugePresion4.value = parseInt(this.presionT4);
          this.gaugePresion4.update();
        }
      }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        this.establishment1Subscription = this.deviceService.getEstablishmentDataNew(this.dispostivoData.dev_est_id).subscribe({
          next:resp =>{
            if(resp.est_imgs !== null){
              this.dev_img_path = this.urlBase + "/uploads/imgs/"+resp.est_imgs;
            }
            this.lat = resp.est_lat;
            this.lng = resp.est_lng;
          },error: err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },complete: ()=>{
            this.datosRecibidos1 = true;
            //Solo hacerlo cuando se carga la pagina por primera vez
            if(this.actualizar !== true){
              setTimeout(() => {
                this.mapService.loadMapScript(this.initMap.bind(this));

                this.dataSourceAlarms.sort = this.sort3;
                this.dataSourceAlarms.paginator = this.paginator1;

                this.dataSourceAlarmsActivas.sort = this.sort2;

                this.dataSource.sort = this.sort1;
              }, 0);
            }
          }
        });
      }
    })
  }

  convertirFechas(listaFechas: string[]): string[] {
    const fechasFormateadas = listaFechas.map((fechaString: string) => {
      const fecha = new Date(fechaString);
      const dia = fecha.getDate();
      const mes = fecha.getMonth() + 1; 
      const año = fecha.getFullYear();
      return `${dia < 10 ? '0' : ''}${dia}-${mes < 10 ? '0' : ''}${mes}-${año} ${fecha.getHours()}:${fecha.getMinutes()}:${fecha.getSeconds()}`;
    });
    return fechasFormateadas;
  }

  actualizarTodayCharts(deviceReference: string, start:string, end:string, timescale:string) {
    let historialObservable;
    if (this.llamarOptimizada) {
      historialObservable = this.deviceService.getMultiHistoricNoScale(deviceReference, start, end);
    } else {
      historialObservable = this.deviceService.getMultiHistoricRaw(deviceReference, start, end, this.selectedValue);
    }
    const nombreCampoLecturas = this.llamarOptimizada ? 'readers' : 'readers_raw';
    this.historialSubscription = historialObservable.subscribe({
      next: (resp) => {
        //console.log(this.deviceHistoryMap[deviceReference]);
        /*Si la nueva respuesta es más grande que la primera respuesta de historicos significa
        que se ha recibido un nuevo historico*/
        if(resp[0][nombreCampoLecturas].length > this.tamañoHistorOriginal){
          console.log("Nuevo histórico recibido");
          this.tamañoHistorOriginal = resp[0][nombreCampoLecturas].length;
          this.deviceHistoryMap[deviceReference] = resp[0][nombreCampoLecturas];
          const deviceHistory = this.deviceHistoryMap[deviceReference];
          const ultimoHistorial = deviceHistory.length-1;
          let timeLabels: string [] = [];
          const temperaturaTanque1: any = [];
          const temperaturaTanque2: any = [];
          const temperaturaTanque3: any = [];
          const temperaturaTanque4: any= [];
          const temperaturaAmbiente: any = [];
          const presionTanque1: any = [];
          const presionTanque2: any = [];
          const presionTanque3: any = [];
          const presionTanque4: any = [];
          const caudalTanque1: any = [];
          const caudalTanque2: any = [];
          const caudalTanque3: any = [];
          const caudalTanque4: any = [];
          const nivelTanque1: any = [];
          const nivelTanque2: any = [];
          const nivelTanque3: any = [];
          const nivelTanque4: any = [];

          //Calcular las horas 
          const primeraFecha = new Date(deviceHistory[0].created_at);
          const ultimaFecha = new Date(deviceHistory[deviceHistory.length - 1].created_at);
          let diferenciaHoras = (+ultimaFecha - +primeraFecha) / (1000 * 60 * 60); 
          diferenciaHoras = parseFloat(diferenciaHoras.toFixed(2));
  
          const soloDosDecimalesConComa = (numero: any) => {
            return numero.toLocaleString(this.userServiceData.region, { maximumFractionDigits: 2 });
          };
  
          const fechaOriginal = new Date(start);
          const fechaSumada = new Date(fechaOriginal);
          fechaSumada.setDate(fechaOriginal.getDate() + 1);
          let variosDiasHistorico = false;
          //Si se muestra más de un día
          if(end > fechaSumada.toISOString().split("T")[0]){
            variosDiasHistorico = true;
          }
          const createdAt = deviceHistory[ultimoHistorial].created_at;
          timeLabels.push(createdAt);
          /*if(!variosDiasHistorico){
            const hora = this.conseguirHoraEnFecha(createdAt);
            timeLabels.push(hora);
          } else{
            timeLabels.push(createdAt);
            let listaTiemposSinSegundos: any[] = timeLabels.map(tiempoConSegundos => {
              // Dividir la cadena en fecha y hora
              let [fecha, hora] = tiempoConSegundos.split(' ');
              // Dividir la hora en partes usando el caracter ':'
              let partesHora: string[] = hora.split(':');
              // Unir las partes de hora y minutos para formar la nueva cadena sin segundos
              let nuevaHora: string = partesHora[0] + ':' + partesHora[1];
              // Construir la cadena final
              return fecha + ' ' + nuevaHora;
            });
            timeLabels = listaTiemposSinSegundos;
          }*/
          temperaturaTanque1.push(deviceHistory[ultimoHistorial].field6);
          temperaturaTanque2.push(deviceHistory[ultimoHistorial].field7);
          temperaturaTanque3.push(deviceHistory[ultimoHistorial].field8);
          temperaturaTanque4.push(deviceHistory[ultimoHistorial].field24)
          temperaturaAmbiente.push(deviceHistory[ultimoHistorial].field9);
          presionTanque1.push(deviceHistory[ultimoHistorial].field3);
          presionTanque2.push(deviceHistory[ultimoHistorial].field4);
          presionTanque3.push(deviceHistory[ultimoHistorial].field5);
          presionTanque4.push(deviceHistory[ultimoHistorial].field23)
          caudalTanque1.push((deviceHistory[ultimoHistorial].field11)+(deviceHistory[ultimoHistorial].field12)+(deviceHistory[ultimoHistorial].field20));
          caudalTanque2.push((deviceHistory[ultimoHistorial].field13)+(deviceHistory[ultimoHistorial].field14)+(deviceHistory[ultimoHistorial].field21));
          caudalTanque3.push((deviceHistory[ultimoHistorial].field15)+(deviceHistory[ultimoHistorial].field16)+(deviceHistory[ultimoHistorial].field22));
          caudalTanque4.push((deviceHistory[ultimoHistorial].field26)+(deviceHistory[ultimoHistorial].field27)+(deviceHistory[ultimoHistorial].field28));
          nivelTanque1.push(deviceHistory[ultimoHistorial].field17);
          nivelTanque2.push(deviceHistory[ultimoHistorial].field18);
          nivelTanque3.push(deviceHistory[ultimoHistorial].field19);
          nivelTanque4.push(deviceHistory[ultimoHistorial].field25);

          //ESTADÍSTICAS DE TEMPERATURA
          const daotsTemperatura = [temperaturaTanque1, temperaturaTanque2, temperaturaTanque3, temperaturaTanque4, temperaturaAmbiente];
          for (let i = 0; i < daotsTemperatura.length; i++) {
            if(this.hayAlgunValor(daotsTemperatura[i])){
              for (let j = 0; j < this.datosEstadisticosTemperatura.length; j++) {
                let nombreTanque = `Tanque ${i + 1}`;
                if(i == 4){
                  nombreTanque = 'Temp. Ambiente';
                }
                //Si el elemento ya existe solo guardamos el ultimo dato y recarlculamos
                if(this.datosEstadisticosTemperatura[j].nombre == nombreTanque){
                  this.datosEstadisticosTemperatura[j].historico.push(daotsTemperatura[i]);
                  const historico = this.datosEstadisticosTemperatura[j].historico;
                  const historicoNumeros = historico.map(Number).filter((val:any) => !isNaN(val));
                  const maximo = Math.max(...historicoNumeros);
                  const minimo = Math.min(...historicoNumeros);
                  const media = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0) / historicoNumeros.length;

                  this.datosEstadisticosTemperatura[j].nombre = nombreTanque;
                  this.datosEstadisticosTemperatura[j].maxima = this.soloDosDecimalesConComa(maximo);
                  this.datosEstadisticosTemperatura[j].minima = this.soloDosDecimalesConComa(minimo);
                  this.datosEstadisticosTemperatura[j].media = this.soloDosDecimalesConComa(media);
                }
                const elementoExistente = this.datosEstadisticosTemperatura.find((item:any) => item.nombre === nombreTanque)
                if(!elementoExistente){
                  //En caso de que un tanque nuevo entre
                  const historico = daotsTemperatura[i];
                  const historicoNumeros = historico.map(Number).filter((val:any) => !isNaN(val));
                  const maximo = Math.max(...historicoNumeros);
                  const minimo = Math.min(...historicoNumeros);
                  const media = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0) / historicoNumeros.length;
                  this.datosEstadisticosTemperatura.push({
                    nombre: nombreTanque,
                    historico: historicoNumeros,
                    maxima: this.soloDosDecimalesConComa(maximo),
                    minima: this.soloDosDecimalesConComa(minimo),
                    media: this.soloDosDecimalesConComa(media),
                  });
                }
              }
            }
          }
          const todosLosHistoricosT: number[] = [];
          for (const estadistica of this.datosEstadisticosTemperatura) {
            // No tenemos en cuenta la temperatura ambiente
            if (estadistica.nombre !== 'Temp. Ambiente') {
              for (const valor of estadistica.historico) {
                const numero = Array.isArray(valor) ? valor[0] : valor;
                if (!isNaN(numero)) {
                  todosLosHistoricosT.push(numero);
                }
              }
            }
          }
          const maximoGlobalT = Math.max(...todosLosHistoricosT);
          const minimoGlobalT = Math.min(...todosLosHistoricosT);
          const mediaGlobalT = todosLosHistoricosT.reduce((acc:any, val:any) => acc + val, 0) / todosLosHistoricosT.length;
          this.datosEstadisticosTemperaturaTodos = {
            nombre: 'TEMP.',
            historico: todosLosHistoricosT,
            maxima: this.soloDosDecimalesConComa(maximoGlobalT),
            minima: this.soloDosDecimalesConComa(minimoGlobalT),
            media: this.soloDosDecimalesConComa(mediaGlobalT),
          };

          //ESTADISTICAS DE PRESION
          const daotsPresion = [presionTanque1, presionTanque2, presionTanque3, presionTanque4];
          for (let i = 0; i < daotsPresion.length; i++) {
            if(this.hayAlgunValor(daotsPresion[i])){
            for (let j = 0; j < this.datosEstadisticosPresion.length; j++) {
              let nombreTanque = `Tanque ${i + 1}`;
              //Si el elemento ya existe solo guardamos el ultimo dato y recarlculamos
              if(this.datosEstadisticosPresion[j].nombre == nombreTanque){
                this.datosEstadisticosPresion[j].historico.push(daotsPresion[i]);
                const historico = this.datosEstadisticosPresion[j].historico;
                const historicoNumeros = historico.map(Number).filter((val:any) => !isNaN(val));
                const maximo = Math.max(...historicoNumeros);
                const minimo = Math.min(...historicoNumeros);
                const media = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0) / historicoNumeros.length;

                this.datosEstadisticosPresion[j].nombre = nombreTanque;
                this.datosEstadisticosPresion[j].maxima = this.soloDosDecimalesConComa(maximo);
                this.datosEstadisticosPresion[j].minima = this.soloDosDecimalesConComa(minimo);
                this.datosEstadisticosPresion[j].media = this.soloDosDecimalesConComa(media);
              }
              const elementoExistente = this.datosEstadisticosPresion.find((item:any) => item.nombre === nombreTanque)
              if(!elementoExistente){
                //En caso de que un tanque nuevo entre
                const historico = daotsPresion[i];
                const historicoNumeros = historico.map(Number).filter((val:any) => !isNaN(val));
                const maximo = Math.max(...historicoNumeros);
                const minimo = Math.min(...historicoNumeros);
                const media = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0) / historicoNumeros.length;
                this.datosEstadisticosPresion.push({
                  nombre: nombreTanque,
                  historico: historicoNumeros,
                  maxima: this.soloDosDecimalesConComa(maximo),
                  minima: this.soloDosDecimalesConComa(minimo),
                  media: this.soloDosDecimalesConComa(media),
                });
              }
            }
            }
          }
          const todosLosHistoricosP: number[] = [];
          for (const estadistica of this.datosEstadisticosPresion) {
            for (const valor of estadistica.historico) {
              const numero = Array.isArray(valor) ? valor[0] : valor;
              if (!isNaN(numero)) {
                todosLosHistoricosP.push(numero);
              }
            }
          }
          const maximoGlobalP = Math.max(...todosLosHistoricosP);
          const minimoGlobalP = Math.min(...todosLosHistoricosP);
          const mediaGlobalP = todosLosHistoricosP.reduce((acc, val) => acc + val, 0) / todosLosHistoricosP.length;
          this.datosEstadisticosPresionTodos = {
            nombre: 'PRESION',
            historico: todosLosHistoricosP,
            maxima: this.soloDosDecimalesConComa(maximoGlobalP),
            minima: this.soloDosDecimalesConComa(minimoGlobalP),
            media: this.soloDosDecimalesConComa(mediaGlobalP),
          };

          //ESTADISTICAS DE CONSUMO
          const imagenesCerveza = [
            [this.imagenCervezaT1, this.imagenCervezaT1Url],
            [this.imagenCervezaT2, this.imagenCervezaT2Url],
            [this.imagenCervezaT3, this.imagenCervezaT3Url],
            [this.imagenCervezaT4, this.imagenCervezaT4Url],
          ]
          const datosConsumo = [caudalTanque1, caudalTanque2, caudalTanque3, caudalTanque4];
          for (let i = 0; i < datosConsumo.length; i++) {
            if(this.hayAlgunValor(datosConsumo[i])){
            for (let j = 0; j < this.datosEstadisticosConsumo.length; j++) {
              let nombreTanque = `Tanque ${i + 1}`;
              //Si el elemento ya existe solo guardamos el ultimo dato y recarlculamos
              if(this.datosEstadisticosConsumo[j].nombre == nombreTanque){
                this.datosEstadisticosConsumo[j].historico.push(datosConsumo[i]);
                const historico = this.datosEstadisticosConsumo[j].historico;
                const historicoNumeros = historico.map(Number).filter((val:any) => !isNaN(val));
                const maximo = Math.max(...historicoNumeros);
                const minimo = Math.min(...historicoNumeros);
                const media = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0) / historicoNumeros.length;
                const sumaTotal = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0);
                const litrosHora = sumaTotal / diferenciaHoras;
                const litrosDia = sumaTotal / this.diferenciaDias;
                this.datosEstadisticosConsumo[j].nombre = nombreTanque;
                this.datosEstadisticosConsumo[j].maxima = this.soloDosDecimalesConComa(maximo);
                this.datosEstadisticosConsumo[j].minima = this.soloDosDecimalesConComa(minimo);
                this.datosEstadisticosConsumo[j].media = this.soloDosDecimalesConComa(media);
                this.datosEstadisticosConsumo[j].total = this.soloDosDecimalesConComa(sumaTotal);
                this.datosEstadisticosConsumo[j].canhas = this.soloDosDecimalesConComa(parseFloat((sumaTotal/0.33).toFixed(0)));
                this.datosEstadisticosConsumo[j].ritmoCanhas = this.soloDosDecimalesConComa(parseFloat((litrosHora/0.33).toFixed(2)));
                this.datosEstadisticosConsumo[j].ritmoCanhasDia = this.soloDosDecimalesConComa(parseFloat((litrosDia/0.33).toFixed(2)));
                this.datosEstadisticosConsumo[j].imagen = imagenesCerveza[i][0];
                this.datosEstadisticosConsumo[j].imagenURL = imagenesCerveza[i][1];
              }
              const elementoExistente = this.datosEstadisticosConsumo.find((item:any) => item.nombre === nombreTanque)
              if(!elementoExistente){
                //En caso de que un tanque nuevo entre
                const historico = datosConsumo[i];
                const historicoNumeros = historico.map(Number).filter((val:any) => !isNaN(val));
                const maximo = Math.max(...historicoNumeros);
                const minimo = Math.min(...historicoNumeros);
                const media = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0) / historicoNumeros.length;
                const sumaTotal = historicoNumeros.reduce((acc:any, val:any) => acc + val, 0);
                const litrosHora = sumaTotal / diferenciaHoras;
                const litrosDia = sumaTotal / this.diferenciaDias;
                this.datosEstadisticosConsumo.push({
                  nombre: nombreTanque,
                  historico: historicoNumeros,
                  maxima: this.soloDosDecimalesConComa(maximo),
                  minima: this.soloDosDecimalesConComa(minimo),
                  media: this.soloDosDecimalesConComa(media),
                  total: this.soloDosDecimalesConComa(sumaTotal),
                  canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotal/0.33).toFixed(0))),
                  ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHora/0.33).toFixed(2))),
                  ritmoCanhasDia: this.soloDosDecimalesConComa(parseFloat((litrosDia/0.33).toFixed(2))),
                  imagen: imagenesCerveza[i][0],
                  imagenURL: imagenesCerveza[i][1],
                });
              }
            }
            }
          }
          const todosLosHistoricosC: number[] = [];
          for (const estadistica of this.datosEstadisticosConsumo) {
            for (const valor of estadistica.historico) {
              const numero = Array.isArray(valor) ? valor[0] : valor;
              if (!isNaN(numero)) {
                todosLosHistoricosC.push(numero);
              }
            }
          }
          const maximoGlobalC = Math.max(...todosLosHistoricosC);
          const minimoGlobalC = Math.min(...todosLosHistoricosC);
          const mediaGlobalC = todosLosHistoricosC.reduce((acc, val) => acc + val, 0) / todosLosHistoricosC.length;
          const sumaTotal = todosLosHistoricosC.reduce((acc, val) => acc + val, 0);
          const litrosHora = sumaTotal / diferenciaHoras;
          const litrosDia = sumaTotal / this.diferenciaDias;
          this.datosEstadisticosConsumoTodos = {
            nombre: 'CONSUMO',
            historico: todosLosHistoricosC,
            maxima: this.soloDosDecimalesConComa(maximoGlobalC),
            minima: this.soloDosDecimalesConComa(minimoGlobalC),
            media: this.soloDosDecimalesConComa(mediaGlobalC),
            total: this.soloDosDecimalesConComa(sumaTotal),
            canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotal/0.33).toFixed(0))),
            ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHora/0.33).toFixed(2))),
            ritmoCanhasDias: this.soloDosDecimalesConComa(parseFloat((litrosDia/0.33).toFixed(2))),
          };

          /*let endDate = new Date(end);
          endDate.setDate(endDate.getDate() - 1);
          timeLabels = this.quitarAnioYMesSiMismoAnioYMes(timeLabels, start, endDate.toISOString().split('T')[0]);*/
          //Añadirlo solo una vez, sino se multiplica x3
          /*if(this.charts[0].data.labels){
            this.charts[0].data.labels.push(timeLabels[0]);
          }*/
  
          const datasetsLabelsTemperatura = [
            [' Tª tanque 1', temperaturaTanque1[0]],
            [' Tª tanque 2', temperaturaTanque2[0]],
            [' Tª tanque 3', temperaturaTanque3[0]],
            [' Tª tanque 4', temperaturaTanque4[0]],
            [' Tª Ambiente', temperaturaAmbiente[0]]
          ]
          const datasetsLabelsPresion = [
            [' P tanque 1', presionTanque1[0]],
            [' P tanque 2', presionTanque2[0]],
            [' P tanque 3', presionTanque3[0]],
            [' P tanque 4', presionTanque4[0]],
          ]
          let caudalTanque1form = caudalTanque1[0] !== 0 ? caudalTanque1[0] : null;
          let caudalTanque2form = caudalTanque2[0] !== 0 ? caudalTanque2[0] : null;
          let caudalTanque3form = caudalTanque3[0] !== 0 ? caudalTanque3[0] : null;
          let caudalTanque4form = caudalTanque4[0] !== 0 ? caudalTanque4[0] : null;
          let nivelTanque1form = nivelTanque1[0] !== 0 ? nivelTanque1[0] : null;
          let nivelTanque2form = nivelTanque2[0] !== 0 ? nivelTanque2[0] : null;
          let nivelTanque3form = nivelTanque3[0] !== 0 ? nivelTanque3[0] : null;
          let nivelTanque4form = nivelTanque4[0] !== 0 ? nivelTanque4[0] : null;
          const datasetsLabelsNivelConsumo = [
            [' Nivel tanque 1', nivelTanque1form],
            [' Nivel tanque 2', nivelTanque2form],
            [' Nivel tanque 3', nivelTanque3form],
            [' Nivel tanque 4', nivelTanque4form],
            [' Consumo tanque 1', caudalTanque1form],
            [' Consumo tanque 2', caudalTanque2form],
            [' Consumo tanque 3', caudalTanque3form],
            [' Consumo tanque 4', caudalTanque4form],
          ]
          this.charts.forEach((chart:any)=> {
            if (chart.canvas.id == "Temperatura") {
              for (let i = 0; i < datasetsLabelsTemperatura.length; i++) {
                const currentLabel = datasetsLabelsTemperatura[i][0];
                const currentValue = datasetsLabelsTemperatura[i][1];
                // Ver si la label existe en algún dataset
                if (currentValue !== null) {
                  const labelExists = chart.data.datasets.some((dataset: any) => dataset.label === currentLabel);
                  if (labelExists) {
                    // Si ya existe solo agrego el nuevo valor
                    const matchingDataset = chart.data.datasets.find((dataset: any) => dataset.label === currentLabel);
                    const pointDataTemperatura = [];
                    const date = new Date (timeLabels[0]);
                    pointDataTemperatura.push({
                      x: date,
                      y: currentValue
                    });
                    matchingDataset.data.push(pointDataTemperatura[0]);
                  }
                  if (!labelExists) {
                    const labelsLength = chart.data.labels.length;
                    // Rellenar con nullos hasta alcanzar el número de labels, sino empieza añadiendo por el principio
                    const nullValues = Array(labelsLength - 1).fill(null);
                    // Generar un color random ya que sino lo pone en gris
                    const randomColor = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.5)`;
                    const pointDataTemperatura = [];
                    const date = new Date (timeLabels[0]);
                    pointDataTemperatura.push({
                      x: date,
                      y: currentValue
                    });
                    const newDataset = {
                      label: currentLabel,
                      data: [...nullValues, { x: timeLabels[0], y: pointDataTemperatura[0] }],
                      borderWidth: 1,
                      pointBorderWidth: 10,
                      pointHoverRadius: 10,
                      pointHoverBorderWidth: 1,
                      pointRadius: 0,
                      backgroundColor: randomColor,
                      borderColor: randomColor,
                      fill: false,
                    };
                    chart.data.datasets.push(newDataset);
                  }
                }
              }
            }
            if (chart.canvas.id == "Presion") {
              for (let i = 0; i < datasetsLabelsPresion.length; i++) {
                const currentLabel = datasetsLabelsPresion[i][0];
                const currentValue = datasetsLabelsPresion[i][1];
                // Ver si la label existe en algún dataset
                if (currentValue !== null) {
                  const labelExists = chart.data.datasets.some((dataset: any) => dataset.label === currentLabel);
                  if (labelExists) {
                    // Si ya existe solo agrego el nuevo valor
                    const matchingDataset = chart.data.datasets.find((dataset: any) => dataset.label === currentLabel);
                    const pointDataPresion = [];
                    const date = new Date (timeLabels[0]);
                    pointDataPresion.push({
                      x: date,
                      y: currentValue
                    });
                    matchingDataset.data.push(pointDataPresion[0]);
                  }
                  if (!labelExists) {
                    const labelsLength = chart.data.labels.length;
                    // Rellenar con nullos hasta alcanzar el número de labels, sino empieza añadiendo por el principio
                    const nullValues = Array(labelsLength - 1).fill(null);
                    // Generar un color random ya que sino lo pone en gris
                    const randomColor = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.5)`;
                    const pointDataPresion = [];
                    const date = new Date (timeLabels[0]);
                    pointDataPresion.push({
                      x: date,
                      y: currentValue
                    });
                    const newDataset = {
                      label: currentLabel,
                      data: [...nullValues, pointDataPresion[0]],
                      borderWidth: 1,
                      pointBorderWidth: 10,
                      pointHoverRadius: 10,
                      pointHoverBorderWidth: 1,
                      pointRadius: 0,
                      backgroundColor: randomColor,
                      borderColor: randomColor,
                      fill: false,
                    };
                    chart.data.datasets.push(newDataset);
                  }
                }
              }
            }
            if (chart.canvas.id == "Nivel-Consumo") {
              for (let i = 0; i < datasetsLabelsNivelConsumo.length; i++) {
                const currentLabel = datasetsLabelsNivelConsumo[i][0];
                const currentValue = datasetsLabelsNivelConsumo[i][1];
                // Ver si la label existe en algún dataset
                if (currentValue !== null) {
                  const labelExists = chart.data.datasets.some((dataset: any) => dataset.label === currentLabel);
                  if (labelExists) {
                    // Si ya existe solo agrego el nuevo valor
                    const matchingDataset = chart.data.datasets.find((dataset: any) => dataset.label === currentLabel);
                    const pointDataNivelConsumo = [];
                    const date = new Date (timeLabels[0]);
                    pointDataNivelConsumo.push({
                      x: date,
                      y: currentValue
                    });
                    matchingDataset.data.push(pointDataNivelConsumo[0]);
                  }
                  if (!labelExists) {
                    const labelsLength = chart.data.labels.length;
                    console.log(chart.data);
                    console.log(labelsLength);
                    // Rellenar con nullos hasta alcanzar el número de labels, sino empieza añadiendo por el principio
                    const nullValues = Array(labelsLength - 1).fill(null);
                    let color;
                    let fill;
                    let yAxisID;
                    if (i > 3) {
                      yAxisID = 'y1';
                      fill = true;
                      color = 'rgba(204, 204, 204)';
                    } else {
                      yAxisID = 'y';
                      fill = false;
                      color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.5)`;
                    }
                    const pointDataNivelConsumo = [];
                    const date = new Date (timeLabels[0]);
                    pointDataNivelConsumo.push({
                      x: date,
                      y: currentValue
                    });
                    const newDataset = {
                      label: currentLabel,
                      data: [...nullValues, pointDataNivelConsumo[0]],
                      borderWidth: 1,
                      pointBorderWidth: 10,
                      pointHoverRadius: 10,
                      pointHoverBorderWidth: 1,
                      pointRadius: 0,
                      backgroundColor: color,
                      borderColor: color,
                      yAxisID: yAxisID,
                      fill: fill,
                    };
                    chart.data.datasets.push(newDataset);
                  }
                }
              }
            }
            chart.update();
          });
        }
      }, error:err =>{
        console.log(err);
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:() =>{}
    });
  }

  hayAlgunValor(lista: any){
    return lista.length > 0 && lista.some((value:any) => value !== null && !Number.isNaN(value) && value !== undefined && value !== "0.00" && value !== 0 )
  }

  obtenerDiaSiguiente(diaActual: string): string {
    const fechaObjeto = new Date(diaActual);
    const diaSiguiente = addDays(fechaObjeto, 1);
    return diaSiguiente.toISOString().slice(0, 10);
  }

  // CALCULAR CONSUMO DEL DÍA

    calcularConsumoDiaActual(deviceReference: string){
      this.consumoDiaActual = [];
      return new Promise<void>((resolve, reject) => {
        const diaSiguiente = this.obtenerDiaSiguiente(this.fechaFormateada);
        this.historicoDiaSubscription = this.deviceService.getMultiHistoricRaw(deviceReference, this.fechaFormateada, diaSiguiente, "0").subscribe({
          next: resp => {
            const camposTanque1 = ['field11', 'field12', 'field20'];
            const camposTanque2 = ['field13', 'field14', 'field21'];
            const camposTanque3 = ['field15', 'field16', 'field22'];
            const camposTanque4 = ['field26', 'field27', 'field28'];
    
            for (let i = 0; i < resp.length; i++) {
              const tanques = {
                tanque1: this.obtenerDatosTanque(resp[i], camposTanque1, 'beer_type_id_1'),
                tanque2: this.obtenerDatosTanque(resp[i], camposTanque2, 'beer_type_id_2'),
                tanque3: this.obtenerDatosTanque(resp[i], camposTanque3, 'beer_type_id_3'),
                tanque4: this.obtenerDatosTanque(resp[i], camposTanque4, 'beer_type_id_4'),
              };

              const consumoTotal = this.calcularConsumoTotal([tanques.tanque1.consumo, tanques.tanque2.consumo, tanques.tanque3.consumo, tanques.tanque4.consumo]);
    
              this.consumoDiaActual.push({
                dispositivoId: resp[i].id,
                establecimientoId: resp[i].dev_est_id,
                tanques: tanques,
                consumoTotal: consumoTotal,
              });
            }
          },
          error: err => {
            reject(err);
          },
          complete: () => {
            this.calcularConsumoEnTanques();
            resolve();
          },
        });
      });
    }

    calcularConsumoTotal(consumos: number[]): number {
      return parseFloat((consumos.reduce((total, consumo) => total + consumo, 0)).toFixed(2));
    }

    obtenerDatosTanque(respItem: any, camposTanque: string[], cervezaProp: string): { cervezaId: string | null; consumo: number } {
      return {
        cervezaId: respItem.readers_raw[0]?.[cervezaProp] || null,
        consumo: this.calcularConsumoTanque(respItem.readers_raw, camposTanque),
      };
    }
    
    calcularConsumoTanque(readersRaw: any[], campos: string[]): number {
      let consumoTanque = 0;
      readersRaw.forEach(reader => {
        campos.forEach(campo => {
          if (reader && reader[campo] !== undefined) {
            consumoTanque += parseFloat(reader[campo] !== null ? reader[campo] : 0);
          } else {
            consumoTanque += 0;
          }
        });
      });
      return parseFloat(consumoTanque.toFixed(2));
    }

    calcularConsumoEnTanques() {
      const listaAuxiliar: any = [];
      this.consumoDiaActual.forEach((consumo: any) => {
        const { dispositivoId, tanques } = consumo;
        
        listaAuxiliar.push({
          deviceId: dispositivoId,
          slot: 1,
          consumo: tanques.tanque1.consumo,
        });
        listaAuxiliar.push({
          deviceId: dispositivoId,
          slot: 2,
          consumo: tanques.tanque2.consumo,
        });
        listaAuxiliar.push({
          deviceId: dispositivoId,
          slot: 3,
          consumo: tanques.tanque3.consumo,
        });
        listaAuxiliar.push({
          deviceId: dispositivoId,
          slot: 4,
          consumo: tanques.tanque4.consumo,
        });
      });
      this.litrosConsumidosPorTanque = listaAuxiliar;
    }

    devolverConsumoEnTanque(deviceId: number, slot: number): number {
      const datoTanque = this.litrosConsumidosPorTanque.find(
        (dato: DatosTanque) => dato.deviceId === deviceId && dato.slot === slot
      );
      return datoTanque ? datoTanque.consumo : 0;
    }

  calcularConRawDatosDelDiaActual(start: string, end: string, deviceReference: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const readers_raw: any = [];
      let scale = "5";
      if(!this.escalaDias){
        scale = "60" 
      }
  
      this.historialRawSubscription = this.deviceService.getMultiHistoricRaw(deviceReference, start, end, scale).subscribe({
        next: (resp) => {
          for (let i = 0; i < resp.length; i++) {
            readers_raw.push(resp[i].readers_raw);
          }
        },
        error: (err) => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
            reject(err);
          } else {
            this.errorMessage = err.error.message;
            reject(err);
          }
        },
        complete: () => {
          resolve(readers_raw);
        }
      });
    });
  }

  resumirHistoricosDelDia(){
    const historicoEstablecimiento: any = [];
    for(let i=0; i<this.readersRawDiaActual.length; i++){
      let beer_type_id_1 = null;
      let beer_type_id_2 = null;
      let beer_type_id_3 = null;
      let beer_type_id_4 = null;
      let created_at = null;
      let dev_id = null;
      let field0 = null;
      let field1 = null;
      let field2 = null;
      let field3 = null;
      let field4 = null;
      let field5 = null;
      let field6 = null;
      let field7 = null;
      let field8 = null;
      let field9 = null;
      let field10 = null;
      let field11 = null;
      let field12 = null;
      let field13 = null;
      let field14 = null;
      let field15 = null;
      let field16 = null;
      let field17 = null;
      let field18 = null;
      let field19 = null;
      let field20 = null;
      let field21 = null;
      let field22 = null;
      let field23 = null;
      let field24 = null;
      let field25 = null;
      let field26 = null;
      let field27 = null;
      let field28 = null;
      let id = null;
      let status = null;
      created_at = this.readersRawDiaActual[i][0].created_at; // Primero
      for (let j = 0; j < this.readersRawDiaActual[i].length; j++) {
        beer_type_id_1 = this.readersRawDiaActual[i][j].beer_type_id_1; // Último
        beer_type_id_2 = this.readersRawDiaActual[i][j].beer_type_id_2; // Último
        beer_type_id_3 = this.readersRawDiaActual[i][j].beer_type_id_3; // Último
        beer_type_id_4 = this.readersRawDiaActual[i][j].beer_type_id_4; // Último
        dev_id = this.readersRawDiaActual[i][j].dev_id; // Último
        field0 = this.readersRawDiaActual[i][j].field0; // Último
        field1 = this.readersRawDiaActual[i][j].field1; // Último
        field2 = this.readersRawDiaActual[i][j].field2; // Último
        field3 = (field3 || 0) + this.readersRawDiaActual[i][j].field3; // Media
        field4 = (field4 || 0) + this.readersRawDiaActual[i][j].field4; // Media
        field5 = (field5 || 0) + this.readersRawDiaActual[i][j].field5; // Media
        field6 = (field6 || 0) + this.readersRawDiaActual[i][j].field6; // Media
        field7 = (field7 || 0) + this.readersRawDiaActual[i][j].field7; // Media
        field8 = (field8 || 0) + this.readersRawDiaActual[i][j].field8; // Media
        field9 = (field9 || 0) + this.readersRawDiaActual[i][j].field9; // Media
        field10 = this.readersRawDiaActual[i][j].field10; // Último
        field11 = (field11 || 0) + this.readersRawDiaActual[i][j].field11; // Sumatorio
        field12 = (field12 || 0) + this.readersRawDiaActual[i][j].field12; // Sumatorio
        field13 = (field13 || 0) + this.readersRawDiaActual[i][j].field13; // Sumatorio
        field14 = (field14 || 0) + this.readersRawDiaActual[i][j].field14; // Sumatorio
        field15 = (field15 || 0) + this.readersRawDiaActual[i][j].field15; // Sumatorio
        field16 = (field16 || 0) + this.readersRawDiaActual[i][j].field16; // Sumatorio
        if (field17 === null || this.readersRawDiaActual[i][j].field17 < field17) {
          field17 = this.readersRawDiaActual[i][j].field17; // Minima
        }
        if (field18 === null || this.readersRawDiaActual[i][j].field18 < field18) {
          field18 = this.readersRawDiaActual[i][j].field18; // Minima
        }
        if (field19 === null || this.readersRawDiaActual[i][j].field19 < field19) {
          field19 = this.readersRawDiaActual[i][j].field19; // Minima
        }
        field20 = (field20 || 0) + this.readersRawDiaActual[i][j].field20; // Sumatorio
        field21 = (field21 || 0) + this.readersRawDiaActual[i][j].field21; // Sumatorio
        field22 = (field22 || 0) + this.readersRawDiaActual[i][j].field22; // Sumatorio
        field23 = (field23 || 0) + this.readersRawDiaActual[i][j].field23; // Media
        field24 = (field24 || 0) + this.readersRawDiaActual[i][j].field24; // Media
        if (field25 === null || this.readersRawDiaActual[i][j].field25 < field25) {
          field25 = this.readersRawDiaActual[i][j].field25; // Minima
        }
        field26 = (field26 || 0) + this.readersRawDiaActual[i][j].field26; // Sumatorio
        field27 = (field27 || 0) + this.readersRawDiaActual[i][j].field27; // Sumatorio
        field28 = (field28 || 0) + this.readersRawDiaActual[i][j].field28; // Sumatorio
        id = this.readersRawDiaActual[i][j].id; // Último
        status = this.readersRawDiaActual[i][j].status; // Último
      }
  
      historicoEstablecimiento.push({
        beer_type_id_1,
        beer_type_id_2,
        beer_type_id_3,
        beer_type_id_4,
        created_at,
        dev_id,
        field0,
        field1,
        field2,
        field3: +(field3 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field4: +(field4 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field5: +(field5 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field6: +(field6 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field7: +(field7 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field8: +(field8 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field9: +(field9 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field10,
        field11: +field11.toFixed(2),
        field12: +field12.toFixed(2),
        field13: +field13.toFixed(2),
        field14: +field14.toFixed(2),
        field15: +field15.toFixed(2),
        field16: +field16.toFixed(2),
        field17,
        field18,
        field19,
        field20: +field20.toFixed(2),
        field21: +field21.toFixed(2),
        field22: +field22.toFixed(2),
        field23: +(field23 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field24: +(field24 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field25: +(field25 || 0).toFixed(2), // Redondear (mínima)
        field26,
        field27,
        field28,
        id,
        status,
      });
    }
  
    return historicoEstablecimiento;
  }

  async loadTodayCharts(deviceReference: string, start:string, end:string, timescale:string) {
    this.destroyCharts();
    this.spanGaps = 1250 * 60 * 60;
    this.llamarOptimizada = false;
    this.escalaDias = false;
    this.diaActualIncluido = true;
    this.readersRawDiaActual = [];

    const fecha1 = new Date(start);
    const fecha2 = new Date(end);
    const diferenciaEnMilisegundos =  Math.abs(fecha1.getTime() - fecha2.getTime());
    const diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 3600 * 24);
    if(diferenciaEnDias <= 3){
      this.escalas = [
        {value: '5', viewValue: 'Mínima'},
        {value: '15', viewValue: '15 minutos'},
        {value: '30', viewValue: '30 minutos'},
        {value: '60', viewValue: '60 minutos'},
      ];
    }
    if(diferenciaEnDias > 3){
      if(!(this.selectedValue === '60' || this.selectedValue === '30' || this.selectedValue === '15')){
        this.selectedValue = '15';
      }
      this.escalas = [
        {value: '15', viewValue: '15 minutos'},
        {value: '30', viewValue: '30 minutos'},
        {value: '60', viewValue: '60 minutos'},
      ];
    }
    if(diferenciaEnDias > 7){
      if(!(this.selectedValue === '60' || this.selectedValue === '30')){
        this.selectedValue = '30';
      }
      this.escalas = [
        {value: '30', viewValue: '30 minutos'},
        {value: '60', viewValue: '60 minutos'},
      ];
    }
    if(diferenciaEnDias >= 15){
      this.selectedValue = "60";
      this.escalas = [
        {value: '60', viewValue: '60 minutos'},
      ];
    }

    if(diferenciaEnDias >= 15){
      this.llamarOptimizada = true
    } 
    if(diferenciaEnDias > 30){
      this.escalaDias = true;
      this.spanGaps = 1250 * 60 * 60 * 24 * 1; // Aumentar el span a un dia y una hora y algo
    }

        // Comprobar si el end es igual a la fecha actual más un día
        const hoy = new Date();
        const mañana = new Date(hoy);
        mañana.setDate(hoy.getDate() + 1);
        if (
          mañana.getFullYear() === fecha2.getFullYear() &&
          mañana.getMonth() === fecha2.getMonth() &&
          mañana.getDate() === fecha2.getDate()
        ) {
          this.diaActualIncluido = true;
        } else {
          this.diaActualIncluido = false;
        }

        if (this.diaActualIncluido && this.llamarOptimizada) {
          const start = hoy.toISOString().split('T')[0];
          this.readersRawDiaActual = await this.calcularConRawDatosDelDiaActual(start, end, deviceReference);
        }

    // VER SI UTILIZAR LA OPTIMIZADA O LA RAW
    let historialObservable;
    if (this.llamarOptimizada) {
      historialObservable = this.deviceService.getMultiHistoricNoScale(deviceReference, start, end);
    } else {
      historialObservable = this.deviceService.getMultiHistoricRaw(deviceReference, start, end, this.selectedValue);
    }
    const nombreCampoLecturas = this.llamarOptimizada ? 'readers' : 'readers_raw';

    this.historialSubscription = historialObservable.subscribe({
      next: (resp) => {
        if(resp[0][nombreCampoLecturas].length == 0){
          this.mensajeNoHayDatos = "(No hay datos disponibles en las fechas seleccionadas)";
          this.graficasDatos = false;
          this.fechaCambiadaGraficasCargardas = true;
        } else {
          this.tamañoHistorOriginal = resp[0][nombreCampoLecturas].length;
          this.graficasDatos = true;
          this.deviceHistoryMap[deviceReference] = resp[0][nombreCampoLecturas];
          const canvasT: any = document.getElementById('Temperatura');
          const canvasP: any = document.getElementById('Presion');
          const canvasNC: any = document.getElementById('Nivel-Consumo');
          const ctxT = canvasT.getContext('2d');
          const ctxP = canvasP.getContext('2d');
          const ctxNC = canvasNC.getContext('2d');

          const deviceHistory = this.deviceHistoryMap[deviceReference];
          let timeLabels = [];
          const temperaturaTanque1 = [];
          const temperaturaTanque2 = [];
          const temperaturaTanque3 = [];
          const temperaturaTanque4 = [];
          const temperaturaAmbiente = [];
          const presionTanque1 = [];
          const presionTanque2 = [];
          const presionTanque3 = [];
          const presionTanque4 = [];
          const caudalTanque1 = [];
          const caudalTanque2 = [];
          const caudalTanque3 = [];
          const caudalTanque4 = [];
          const nivelTanque1 = [];
          const nivelTanque2 = [];
          const nivelTanque3 = [];
          const nivelTanque4 = [];

          //Calcular las horas 
          const primeraFecha = new Date(deviceHistory[0].created_at);
          const ultimaFecha = new Date(deviceHistory[deviceHistory.length - 1].created_at);
          let diferenciaHoras = (+ultimaFecha - +primeraFecha) / (1000 * 60 * 60); 
          diferenciaHoras = parseFloat(diferenciaHoras.toFixed(2));
          const diferenciaMilisegundos = Math.abs(primeraFecha.getTime() - ultimaFecha.getTime());
          this.diferenciaDias = Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24));

          const soloDosDecimalesConComa = (numero: any) => {
            return numero.toLocaleString(this.userServiceData.region, { maximumFractionDigits: 2 });
          };

          const fechaOriginal = new Date(start);
          const fechaSumada = new Date(fechaOriginal);
          fechaSumada.setDate(fechaOriginal.getDate() + 1);
          let variosDiasHistorico = false;
          //Si se muestra más de un día
          if(end > fechaSumada.toISOString().split("T")[0]){
            variosDiasHistorico = true;
          }
          //Conseguir los historicos y los datos de Temperatura, Presión, etc. de cada dispositivo
          for(let i=0; i<deviceHistory.length; i++){
            const createdAt = deviceHistory[i].created_at;
            timeLabels.push(createdAt);
            /*const fechaDate = new Date(createdAt);
            this.stringTitulosTiempo = "Fecha (Año-Mes-Día HH:mm)";
            if(!variosDiasHistorico){
              const hora = this.conseguirHoraEnFecha(createdAt);
              this.stringTitulosTiempo = "Fecha (HH:mm)";
              timeLabels.push(hora);
            } else{
              timeLabels.push(createdAt);
              let listaTiemposSinSegundos: any[] = timeLabels.map(tiempoConSegundos => {
                // Dividir la cadena en fecha y hora
                let [fecha, hora] = tiempoConSegundos.split(' ');
                // Dividir la hora en partes usando el caracter ':'
                let partesHora: string[] = hora.split(':');
                // Unir las partes de hora y minutos para formar la nueva cadena sin segundos
                let nuevaHora: string = partesHora[0] + ':' + partesHora[1];
                // Construir la cadena final
                return fecha + ' ' + nuevaHora;
              });
              timeLabels = listaTiemposSinSegundos;
            }*/
            temperaturaTanque1.push(deviceHistory[i].field6);
            temperaturaTanque2.push(deviceHistory[i].field7);
            temperaturaTanque3.push(deviceHistory[i].field8);
            temperaturaTanque4.push(deviceHistory[i].field24)
            temperaturaAmbiente.push(deviceHistory[i].field9);
            presionTanque1.push(deviceHistory[i].field3);
            presionTanque2.push(deviceHistory[i].field4);
            presionTanque3.push(deviceHistory[i].field5);
            presionTanque4.push(deviceHistory[i].field23)
            caudalTanque1.push((deviceHistory[i].field11)+(deviceHistory[i].field12)+(deviceHistory[i].field20));
            caudalTanque2.push((deviceHistory[i].field13)+(deviceHistory[i].field14)+(deviceHistory[i].field21));
            caudalTanque3.push((deviceHistory[i].field15)+(deviceHistory[i].field16)+(deviceHistory[i].field22));
            caudalTanque4.push((deviceHistory[i].field26)+(deviceHistory[i].field27)+(deviceHistory[i].field28));
            nivelTanque1.push(deviceHistory[i].field17);
            nivelTanque2.push(deviceHistory[i].field18);
            nivelTanque3.push(deviceHistory[i].field19);
            nivelTanque4.push(deviceHistory[i].field25);
            //console.log("caudalTanque1: ", caudalTanque1);
          }

          if(this.llamarOptimizada && this.diaActualIncluido && !this.escalaDias){
            for(let i=0; i<this.readersRawDiaActual[0].length; i++){
              timeLabels.push(this.readersRawDiaActual[0][i].created_at);
              temperaturaTanque1.push(this.readersRawDiaActual[0][i].field6);
              temperaturaTanque2.push(this.readersRawDiaActual[0][i].field7);
              temperaturaTanque3.push(this.readersRawDiaActual[0][i].field8);
              temperaturaTanque4.push(this.readersRawDiaActual[0][i].field24)
              temperaturaAmbiente.push(this.readersRawDiaActual[0][i].field9);
              presionTanque1.push(this.readersRawDiaActual[0][i].field3);
              presionTanque2.push(this.readersRawDiaActual[0][i].field4);
              presionTanque3.push(this.readersRawDiaActual[0][i].field5);
              presionTanque4.push(this.readersRawDiaActual[0][i].field23)
              caudalTanque1.push((this.readersRawDiaActual[0][i].field11)+(this.readersRawDiaActual[0][i].field12)+(this.readersRawDiaActual[0][i].field20));
              caudalTanque2.push((this.readersRawDiaActual[0][i].field13)+(this.readersRawDiaActual[0][i].field14)+(this.readersRawDiaActual[0][i].field21));
              caudalTanque3.push((this.readersRawDiaActual[0][i].field15)+(this.readersRawDiaActual[0][i].field16)+(this.readersRawDiaActual[0][i].field22));
              caudalTanque4.push((this.readersRawDiaActual[0][i].field26)+(this.readersRawDiaActual[0][i].field27)+(this.readersRawDiaActual[0][i].field28));
              nivelTanque1.push(this.readersRawDiaActual[0][i].field17);
              nivelTanque2.push(this.readersRawDiaActual[0][i].field18);
              nivelTanque3.push(this.readersRawDiaActual[0][i].field19);
              nivelTanque4.push(this.readersRawDiaActual[0][i].field25);
            }
          }

          if(this.llamarOptimizada && this.diaActualIncluido && this.escalaDias){
            const reasumenDelDiaHistoricos = this.resumirHistoricosDelDia();
            for(let z=0; z<reasumenDelDiaHistoricos.length; z++){
              timeLabels.push(reasumenDelDiaHistoricos[z].created_at);
              temperaturaTanque1.push(reasumenDelDiaHistoricos[z].field6);
              temperaturaTanque2.push(reasumenDelDiaHistoricos[z].field7);
              temperaturaTanque3.push(reasumenDelDiaHistoricos[z].field8);
              temperaturaTanque4.push(reasumenDelDiaHistoricos[z].field24)
              temperaturaAmbiente.push(reasumenDelDiaHistoricos[z].field9);
              presionTanque1.push(reasumenDelDiaHistoricos[z].field3);
              presionTanque2.push(reasumenDelDiaHistoricos[z].field4);
              presionTanque3.push(reasumenDelDiaHistoricos[z].field5);
              presionTanque4.push(reasumenDelDiaHistoricos[z].field23);
              caudalTanque1.push((reasumenDelDiaHistoricos[z].field11)+(reasumenDelDiaHistoricos[z].field12)+(reasumenDelDiaHistoricos[z].field20));
              caudalTanque2.push((reasumenDelDiaHistoricos[z].field13)+(reasumenDelDiaHistoricos[z].field14)+(reasumenDelDiaHistoricos[z].field21));
              caudalTanque3.push((reasumenDelDiaHistoricos[z].field15)+(reasumenDelDiaHistoricos[z].field16)+(reasumenDelDiaHistoricos[z].field22));
              caudalTanque4.push((reasumenDelDiaHistoricos[z].field26)+(reasumenDelDiaHistoricos[z].field27)+(reasumenDelDiaHistoricos[z].field28));
              nivelTanque1.push(reasumenDelDiaHistoricos[z].field17);
              nivelTanque2.push(reasumenDelDiaHistoricos[z].field18);
              nivelTanque3.push(reasumenDelDiaHistoricos[z].field19);
              nivelTanque4.push(reasumenDelDiaHistoricos[z].field25);
            }
          }

          //Restarle un día al end para que no haya problemas con las timeLabels el ultimo día del mes
          /*let endDate = new Date(end);
          endDate.setDate(endDate.getDate() - 1);
          timeLabels = this.quitarAnioYMesSiMismoAnioYMes(timeLabels, start, endDate.toISOString().split('T')[0]);*/
        
          //ESTADÍSTICAS DE TEMPERATURA
          this.datosEstadisticosTemperatura = [];
          const daotsTemperatura = [temperaturaTanque1, temperaturaTanque2, temperaturaTanque3, temperaturaTanque4, temperaturaAmbiente];
          for (let i = 0; i < daotsTemperatura.length; i++) {
            if(this.hayAlgunValor(daotsTemperatura[i])){
              const historico = daotsTemperatura[i];
              const historicoNumeros = historico.map(Number).filter(val => !isNaN(val));
              let nombreTanque = `Tanque ${i + 1}`;
              if(i == 4){
                nombreTanque = 'Temp. Ambiente';
              }
              const maximo = Math.max(...historicoNumeros);
              const minimo = Math.min(...historicoNumeros);
              const media = historicoNumeros.reduce((acc, val) => acc + val, 0) / historicoNumeros.length;
              this.datosEstadisticosTemperatura.push({
                nombre: nombreTanque,
                historico: historicoNumeros,
                maxima: this.soloDosDecimalesConComa(maximo),
                minima: this.soloDosDecimalesConComa(minimo),
                media: this.soloDosDecimalesConComa(media),
              });
            }
          }

          //ESTADISICAS TEMPERATURA TODOS
          const todosLosHistoricosT: number[] = [];
          for (const estadistica of this.datosEstadisticosTemperatura) {
            //No tenemos en cuenta la temperatura ambiente
            if(estadistica.nombre !== 'Temp. Ambiente'){
              todosLosHistoricosT.push(...estadistica.historico);
            }
          }
          const maximoGlobalT = Math.max(...todosLosHistoricosT);
          const minimoGlobalT = Math.min(...todosLosHistoricosT);
          const mediaGlobalT = todosLosHistoricosT.reduce((acc, val) => acc + val, 0) / todosLosHistoricosT.length;
          this.datosEstadisticosTemperaturaTodos = {
            nombre: 'TEMP.',
            historico: todosLosHistoricosT,
            maxima: this.soloDosDecimalesConComa(maximoGlobalT),
            minima: this.soloDosDecimalesConComa(minimoGlobalT),
            media: this.soloDosDecimalesConComa(mediaGlobalT),
          };

          //ESTADISTICAS DE PRESION
          this.datosEstadisticosPresion = [];
          const daotsPresion = [presionTanque1, presionTanque2, presionTanque3, presionTanque4];
          for (let i = 0; i < daotsPresion.length; i++) {
            if(this.hayAlgunValor(daotsPresion[i])){
              const historico = daotsPresion[i];
              const historicoNumeros = historico.map(Number).filter(val => !isNaN(val));
              let nombreTanque = `Tanque ${i + 1}`;
              const maximo = Math.max(...historicoNumeros);
              const minimo = Math.min(...historicoNumeros);
              const media = historicoNumeros.reduce((acc, val) => acc + val, 0) / historicoNumeros.length;
              this.datosEstadisticosPresion.push({
                nombre: nombreTanque,
                historico: historicoNumeros,
                maxima: this.soloDosDecimalesConComa(maximo),
                minima: this.soloDosDecimalesConComa(minimo),
                media: this.soloDosDecimalesConComa(media),
              });
            }
          }
          //ESTADISICAS PRESION TODOS
          const todosLosHistoricosP: number[] = [];
          for (const estadistica of this.datosEstadisticosPresion) {
            todosLosHistoricosP.push(...estadistica.historico);
          }
          const maximoGlobalP = Math.max(...todosLosHistoricosP);
          const minimoGlobalP = Math.min(...todosLosHistoricosP);
          const mediaGlobalP = todosLosHistoricosP.reduce((acc, val) => acc + val, 0) / todosLosHistoricosP.length;
          this.datosEstadisticosPresionTodos = {
            nombre: 'PRESION',
            historico: todosLosHistoricosP,
            maxima: this.soloDosDecimalesConComa(maximoGlobalP),
            minima: this.soloDosDecimalesConComa(minimoGlobalP),
            media: this.soloDosDecimalesConComa(mediaGlobalP),
          };

          //ESTADISTICAS DE CONSUMO
          this.datosEstadisticosConsumo = [];
          const imagenesCerveza = [
            [this.imagenCervezaT1, this.imagenCervezaT1Url],
            [this.imagenCervezaT2, this.imagenCervezaT2Url],
            [this.imagenCervezaT3, this.imagenCervezaT3Url],
            [this.imagenCervezaT4, this.imagenCervezaT4Url],
          ]
          const datosConsumo = [caudalTanque1, caudalTanque2, caudalTanque3, caudalTanque4];
          for (let i = 0; i < datosConsumo.length; i++) {
            if(this.hayAlgunValor(datosConsumo[i])){
              const historico = datosConsumo[i];
              const historicoNumeros = historico.map(Number).filter(val => !isNaN(val));
              let nombreTanque = `Tanque ${i + 1}`;
              const maximo = Math.max(...historicoNumeros);
              const media = historicoNumeros.reduce((acc, val) => acc + val, 0) / historicoNumeros.length;
              const sumaTotal = historicoNumeros.reduce((acc, val) => acc + val, 0);
              const litrosHora = sumaTotal / diferenciaHoras;
              const litrosDia = sumaTotal / this.diferenciaDias;
              this.datosEstadisticosConsumo.push({
                nombre: nombreTanque,
                historico: historicoNumeros,
                maxima: this.soloDosDecimalesConComa(maximo),
                media: this.soloDosDecimalesConComa(media),
                total: this.soloDosDecimalesConComa(sumaTotal),
                canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotal/0.33).toFixed(0))),
                ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHora/0.33).toFixed(2))),
                ritmoCanhasDia: this.soloDosDecimalesConComa(parseFloat((litrosDia/0.33).toFixed(2))),
                imagen: imagenesCerveza[i][0],
                imagenURL: imagenesCerveza[i][1],
              });
            }
          }
          //ESTADISICAS CONSUMO TODOS
          const todosLosHistoricosC: number[] = [];
          for (const estadistica of this.datosEstadisticosConsumo) {
            todosLosHistoricosC.push(...estadistica.historico);
          }
          const maximoGlobalC = Math.max(...todosLosHistoricosC);
          const minimoGlobalC = Math.min(...todosLosHistoricosC);
          const mediaGlobalC = todosLosHistoricosC.reduce((acc, val) => acc + val, 0) / todosLosHistoricosC.length;
          const sumaTotal = todosLosHistoricosC.reduce((acc, val) => acc + val, 0);
          const litrosHora = sumaTotal / diferenciaHoras;
          const litrosDia = sumaTotal / this.diferenciaDias;
          this.datosEstadisticosConsumoTodos = {
            nombre: 'CONSUMO',
            historico: todosLosHistoricosC,
            maxima: this.soloDosDecimalesConComa(maximoGlobalC),
            minima: this.soloDosDecimalesConComa(minimoGlobalC),
            media: this.soloDosDecimalesConComa(mediaGlobalC),
            total: this.soloDosDecimalesConComa(sumaTotal),
            canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotal/0.33).toFixed(0))),
            ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHora/0.33).toFixed(2))),
            ritmoCanhasDia: this.soloDosDecimalesConComa(parseFloat((litrosDia/0.33).toFixed(2))),
          };

          //ESTADISTICAS DE NIVEL
          this.datosEstadisticosNivel = [];
          const datosNivel = [nivelTanque1, nivelTanque2, nivelTanque3, nivelTanque4];
          for (let i = 0; i < datosNivel.length; i++) {
            if(this.hayAlgunValor(datosNivel[i])){
              const historico = datosNivel[i];
              const historicoNumeros = historico.map(Number).filter(val => !isNaN(val));
              let nombreTanque = `Tanque ${i + 1}`;
              const maximo = Math.max(...historicoNumeros);
              const minimo = Math.min(...historicoNumeros);
              const media = historicoNumeros.reduce((acc, val) => acc + val, 0) / historicoNumeros.length;
              const sumaTotal = historicoNumeros.reduce((acc, val) => acc + val, 0);
              this.datosEstadisticosNivel.push({
                nombre: nombreTanque,
                historico: historicoNumeros,
                maxima: this.soloDosDecimalesConComa(maximo),
                minima: this.soloDosDecimalesConComa(minimo),
                media: this.soloDosDecimalesConComa(media),
              });
            }
          }
          /******************************************datasetT**************************************************/
          //Comprobamos que los datos de temperatura no estén vacios y devuelvan por lo menos algún valor no nulo
          let datasetsT: any = [];
          if (temperaturaTanque1.length > 0 && temperaturaTanque1.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataTemperatura = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataTemperatura.push({
                x: date,
                y: temperaturaTanque1[j]
              });
            }
            datasetsT.push({
              label: ' Tª tanque 1',
              data: pointDataTemperatura,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
              yAxisID: 'y'
            });
          }
          if (temperaturaTanque2.length > 0 && temperaturaTanque2.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataTemperatura = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataTemperatura.push({
                x: date,
                y: temperaturaTanque2[j]
              });
            }
            datasetsT.push({
              label: ' Tª tanque 2',
              data: pointDataTemperatura,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
            });
          }
          if (temperaturaTanque3.length > 0 && temperaturaTanque3.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataTemperatura = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataTemperatura.push({
                x: date,
                y: temperaturaTanque3[j]
              });
            }
            datasetsT.push({
              label: ' Tª tanque 3',
              data: pointDataTemperatura,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
            });
          }
          if (temperaturaTanque4.length > 0 && temperaturaTanque4.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataTemperatura = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataTemperatura.push({
                x: date,
                y: temperaturaTanque4[j]
              });
            }
            datasetsT.push({
              label: ' Tª tanque 4',
              data: pointDataTemperatura,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
            });
          }
          if (temperaturaAmbiente.length > 0 && temperaturaAmbiente.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataTemperatura = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataTemperatura.push({
                x: date,
                y: temperaturaAmbiente[j]
              });
            }
            datasetsT.push({
              label: ' Tª Ambiente',
              data: pointDataTemperatura,
              borderWidth: 1,
              borderDash: [5, 5],
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
              hidden: true,
            });
          }
          /******************************************datasetP**************************************************/
          let datasetsP: any = [];
          if (presionTanque1.length > 0 && presionTanque1.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataPresion = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataPresion.push({
                x: date,
                y: presionTanque1[j]
              });
            }
            datasetsP.push({
              label: ' P tanque 1',
              data: pointDataPresion,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
              yAxisID: 'y'
            });
          }
          if (presionTanque2.length > 0 && presionTanque2.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataPresion = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataPresion.push({
                x: date,
                y: presionTanque2[j]
              });
            }
            datasetsP.push({
              label: ' P tanque 2',
              data: pointDataPresion,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
            });
          }
          if (presionTanque3.length > 0 && presionTanque3.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataPresion = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataPresion.push({
                x: date,
                y: presionTanque3[j]
              });
            }
            datasetsP.push({
              label: ' P tanque 3',
              data: pointDataPresion,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
            });
          }
          if (presionTanque4.length > 0 && presionTanque4.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataPresion = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataPresion.push({
                x: date,
                y: presionTanque4[j]
              });
            }
            datasetsP.push({
              label: ' P tanque 4',
              data: pointDataPresion,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
            });
          }
          /******************************************datasetNC**************************************************/
          //A parte de comprobar que no son todo valores nulos también comprobamos que no sean todos cero
          let datasetsNC: any[] = [];
          if (nivelTanque1.length > 0 && nivelTanque1.some(value => value !== null && value !== "0.00" && value !== undefined && value !== 0)) {
            const pointDataNivel = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataNivel.push({
                x: date,
                y: nivelTanque1[j]
              });
            }
            datasetsNC.push({
              label: ' Nivel tanque 1',
              data: pointDataNivel,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
              yAxisID: 'y',
              borderColor: '#36A2EB',
              backgroundColor: '#9AD0F5'
            });
          }
          if (nivelTanque2.length > 0 && nivelTanque2.some(value => value !== null && value !== "0.00" && value !== undefined && value !== 0)) {
            const pointDataNivel = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataNivel.push({
                x: date,
                y: nivelTanque2[j]
              });
            }
            datasetsNC.push({
              label: ' Nivel tanque 2',
              data: pointDataNivel,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
              yAxisID: 'y',
              borderColor: '#FF6384',
              backgroundColor: '#FFB1C1'
            });
          }
          if (nivelTanque3.length > 0 && nivelTanque3.some(value => value !== null && value !== "0.00" && value !== undefined && value !== 0)) {
            const pointDataNivel = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataNivel.push({
                x: date,
                y: nivelTanque3[j]
              });
            }
            datasetsNC.push({
              label: ' Nivel tanque 3',
              data: pointDataNivel,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
              yAxisID: 'y',
              borderColor: '#FF9F40',
              backgroundColor: '#FFCF9F'
            });
          }
          if (nivelTanque4.length > 0 && nivelTanque4.some(value => value !== null && value !== "0.00" && value !== undefined && value !== 0)) {
            const pointDataNivel = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataNivel.push({
                x: date,
                y: nivelTanque4[j]
              });
            }
            datasetsNC.push({
              label: ' Nivel tanque 4',
              data: pointDataNivel,
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              fill: false,
              yAxisID: 'y',
              borderColor: '#FFCD56',
              backgroundColor: '#FFE6AA'
            });
          }
          if (caudalTanque1.length > 0 && caudalTanque1.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataConsumo = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataConsumo.push({
                x: date,
                y: caudalTanque1[j]
              });
            }
            datasetsNC.push({
              yAxisID: 'y1',
              hidden: false,
              label: " Consumo tanque 1",
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              borderWidth: 1,
              fill: true,
              data: pointDataConsumo,
              backgroundColor: 'rgba(204, 204, 204)'
            });
          }
          if (caudalTanque2.length > 0 && caudalTanque2.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataConsumo = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataConsumo.push({
                x: date,
                y: caudalTanque2[j]
              });
            }
            datasetsNC.push({
              yAxisID: 'y1',
              hidden: false,
              label: " Consumo tanque 2",
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              borderWidth: 1,
              fill: true,
              data: pointDataConsumo,
              backgroundColor: 'rgba(204, 204, 204)'
            });
          }
          if (caudalTanque3.length > 0 && caudalTanque3.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataConsumo = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataConsumo.push({
                x: date,
                y: caudalTanque3[j]
              });
            }
            datasetsNC.push({
              yAxisID: 'y1',
              hidden: false,
              label: " Consumo tanque 3",
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              borderWidth: 1,
              fill: true,
              data: pointDataConsumo,
              backgroundColor: 'rgba(204, 204, 204)'
            });
          }
          if (caudalTanque4.length > 0 && caudalTanque4.some(value => value !== null && value !== 0 && value !== undefined && !Number.isNaN(value))) {
            const pointDataConsumo = [];
            for(let j=0; j<timeLabels.length; j++){
              const date = new Date (timeLabels[j]);
              pointDataConsumo.push({
                x: date,
                y: caudalTanque4[j]
              });
            }
            datasetsNC.push({
              yAxisID: 'y1',
              hidden: false,
              label: " Consumo tanque 4",
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              borderWidth: 1,
              fill: true,
              data: pointDataConsumo,
              backgroundColor: 'rgba(204, 204, 204)'
            });
          }
          // Gráfico Temperatura
          this.chartT = new Chart(ctxT, {
            type: 'line',
            data: {
              datasets: datasetsT
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                easing: "easeInOutBack"
              },
              spanGaps: this.spanGaps,
              plugins: {
                tooltip: {
                  usePointStyle: true,
                  callbacks: {
                    labelPointStyle: function(context) {
                      return {
                          pointStyle: 'rect',
                          rotation: 0,
                      };
                    },
                    label: function(context) {
                      const label = context.dataset.label || '';
                      const value = soloDosDecimalesConComa(context.parsed.y);
                      return `${label}: ${value}`;
                    },
                  },
                },
                legend: {
                  position: "top",
                  labels: {
                    boxWidth: 20,
                    font: {
                      size: 10
                    }
                  }
                }
              },
              interaction: {
                mode: 'index',
                intersect: false,
              },
              scales: {
                y: {
                  beginAtZero: true,
                  position: 'left',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    padding: 3,
                    callback: function(value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: 'Grados Celsius',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    },
                  },
                },
                x: {
                  type: 'time',
                  time: {
                    // Luxon format string
                    tooltipFormat: 'dd LLLL yyyy HH:mm',
                    parser: 'yyyy-MM-dd HH:mm',
                  },
                  adapters: {
                    date: {
                        locale: es
                    }
                  },
                  ticks: {
                    maxTicksLimit: 20,
                    padding: 25,
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    callback: function(value, index, values) {
                      const date = new Date(value);
                      const day = date.getDate().toString().padStart(2, '0');
                      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Suma 1 porque en JavaScript los meses empiezan en 0
                      const year = date.getFullYear();
                      const hours = date.getHours().toString().padStart(2, '0');
                      const minutes = date.getMinutes().toString().padStart(2, '0');

                      // Obtener el año del primer y último elemento del primer dataset
                      if (datasetsT && datasetsT.length > 0 && datasetsT[0].data && datasetsT[0].data.length > 0) {
                        const firstYear = datasetsT[0].data[0].x.getFullYear();
                        const lastYear = datasetsT[0].data[datasetsT[0].data.length - 1].x.getFullYear();

                        // Condición para omitir el año si todas las fechas tienen el mismo año
                        const displayYear = (firstYear == lastYear) ? '' : year;
                        const yearSeparator = (firstYear == lastYear) ? '' : '/';

                        return `${day}/${month}${yearSeparator}${displayYear} ${hours}:${minutes}`;
                      }

                      return `${day}/${month}/${year} ${hours}:${minutes}`;
                    },
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: this.stringTitulosTiempo,
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      top: 10
                    }
                  },
                }
              }
            }
          });
          // Gráfico Presion
          this.chartP = new Chart(ctxP, {
            type: 'line',
            data: {
              datasets: datasetsP
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                easing: "easeInOutBack"
              },
              spanGaps: this.spanGaps,
              plugins: {
                tooltip: {
                  usePointStyle: true,
                  callbacks: {
                    labelPointStyle: function(context) {
                      return {
                          pointStyle: 'rect',
                          rotation: 0,
                      };
                    },
                    label: function(context) {
                      const label = context.dataset.label || '';
                      const value = soloDosDecimalesConComa(context.parsed.y);
                      return `${label}: ${value}`;
                    },
                  }
                },
                legend: {
                  position: "top",
                  labels: {
                    boxWidth: 20,
                    font: {
                      size: 10
                    }
                  }
                }
              },
              interaction: {
                mode: 'index',
                intersect: false
              },
              scales: {
                y: {
                  beginAtZero: true,
                  position: 'left',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    padding: 3,
                    callback: function(value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: 'Bares',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    },
                  },
                },
                x: {
                  type: 'time',
                  time: {
                    // Luxon format string
                    tooltipFormat: 'dd LLLL yyyy HH:mm',
                    parser: 'yyyy-MM-dd HH:mm',
                  },
                  adapters: {
                    date: {
                        locale: es
                    }
                  },
                  ticks: {
                    maxTicksLimit: 20,
                    padding: 25,
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    callback: function(value, index, values) {
                      const date = new Date(value);
                      const day = date.getDate().toString().padStart(2, '0');
                      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Suma 1 porque en JavaScript los meses empiezan en 0
                      const year = date.getFullYear();
                      const hours = date.getHours().toString().padStart(2, '0');
                      const minutes = date.getMinutes().toString().padStart(2, '0');

                      // Obtener el año del primer y último elemento del primer dataset
                      if (datasetsP && datasetsP.length > 0 && datasetsP[0].data && datasetsP[0].data.length > 0) {
                        const firstYear = datasetsP[0].data[0].x.getFullYear();
                        const lastYear = datasetsP[0].data[datasetsP[0].data.length - 1].x.getFullYear();

                        // Condición para omitir el año si todas las fechas tienen el mismo año
                        const displayYear = (firstYear == lastYear) ? '' : year;
                        const yearSeparator = (firstYear == lastYear) ? '' : '/';

                        return `${day}/${month}${yearSeparator}${displayYear} ${hours}:${minutes}`;
                      }

                      return `${day}/${month}/${year} ${hours}:${minutes}`;
                    },
                    //autoSkip: false,
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: this.stringTitulosTiempo,
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      top: 10
                    }
                  },
                }
              }
            }
          });
          // Gráfico Nivel/Consumo
          this.chartNC = new Chart(ctxNC, {
            type: 'line',
            data: {
              datasets: datasetsNC
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                easing: "easeInOutBack"
              },
              spanGaps: this.spanGaps,
              plugins: {
                tooltip: {
                  usePointStyle: true,
                  callbacks: {
                    labelPointStyle: function(context) {
                      return {
                          pointStyle: 'rect',
                          rotation: 0,
                      };
                    },
                    label: function(context) {
                      const label = context.dataset.label || '';
                      const value = soloDosDecimalesConComa(context.parsed.y);
                      return `${label}: ${value}`;
                    },
                  }
                },
                legend: {
                  position: "top",
                  labels: {
                    boxWidth: 20,
                    font: {
                      size: 10
                    }
                  }
                },
              },
              interaction: {
                mode: 'index',
                intersect: false
              },
              scales: {
                y: {
                  beginAtZero: true,
                  position: 'left',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    padding: 10,
                    callback: function(value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false,
                    drawTicks: false,
                  },
                  title: {
                    display: true,
                    text: 'Nivel (Litros)',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    },
                  },
                },
                y1: { // Segundo eje Y
                  beginAtZero: true,
                  position: 'right',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    padding: 3,
                    callback: function(value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: 'Consumo (Litros)',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    }
                  }
                },
                x: {
                  type: 'time',
                  time: {
                    // Luxon format string
                    tooltipFormat: 'dd LLLL yyyy HH:mm',
                    parser: 'yyyy-MM-dd HH:mm',
                  },
                  adapters: {
                    date: {
                        locale: es
                    }
                  },
                  ticks: {
                    maxTicksLimit: 20,
                    padding: 25,
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    callback: function(value, index, values) {
                      const date = new Date(value);
                      const day = date.getDate().toString().padStart(2, '0');
                      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Suma 1 porque en JavaScript los meses empiezan en 0
                      const year = date.getFullYear();
                      const hours = date.getHours().toString().padStart(2, '0');
                      const minutes = date.getMinutes().toString().padStart(2, '0');

                      // Obtener el año del primer y último elemento del primer dataset
                      if (datasetsNC && datasetsNC.length > 0 && datasetsNC[0].data && datasetsNC[0].data.length > 0) {
                        const firstYear = datasetsNC[0].data[0].x.getFullYear();
                        const lastYear = datasetsNC[0].data[datasetsNC[0].data.length - 1].x.getFullYear();

                        // Condición para omitir el año si todas las fechas tienen el mismo año
                        const displayYear = (firstYear == lastYear) ? '' : year;
                        const yearSeparator = (firstYear == lastYear) ? '' : '/';

                        return `${day}/${month}${yearSeparator}${displayYear} ${hours}:${minutes}`;
                      }

                      return `${day}/${month}/${year} ${hours}:${minutes}`;
                    },
                    //autoSkip: false,
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: this.stringTitulosTiempo,
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      top: 10
                    }
                  },
                }
              }
            }
          });
          //Guardar en una matriz para luego eliminarlos antes de cargar las nuevas
          this.charts.push(this.chartT);
          this.charts.push(this.chartP);
          this.charts.push(this.chartNC);
          this.fechaCambiadaGraficasCargardas = true;
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:() =>{
        this.fechaCambiadaGraficasCargardas = true;
      }
    });
  }

  calcularTodosLosEstablecimiento(){
    return new Promise<void>((resolve, reject) => {
      this.establecimientosSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
        next: resp =>{
          this.establecimientos = resp;
        }, error: err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete : () => {
          resolve();
        }
      });
    })
  }

  cargarPedidosyRecargas(){
    //const start = "2015-01-01"
    return new Promise<void>((resolve, reject) => {
      const currentDate = new Date();
      const start = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      // Coger los pedidos desde el día de hoy a un año atras
      start.setDate(currentDate.getDate() - 365);
      console.log(start.toISOString().slice(0, 10))
      this.pedidosSubscription = this.deviceService.getPedidos(start.toISOString().slice(0, 10),currentDate.toISOString().slice(0, 10)).subscribe({
        next:resp =>{
          this.pedidos = resp.orders;
          this.pedidos.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete:()=>{
          const establecimientosIDs: any = [];
          for(let x = 0; x < this.establecimientos.length; x++){
            establecimientosIDs.push(this.establecimientos[x].id);
          }
          const recargasData = new FormData();
          recargasData.append('establishments', JSON.stringify(establecimientosIDs));
          this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
            next: resp => {
              this.recargas = resp.charges;
              this.recargas.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
            },error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
              reject(err);
            },complete: () => {
              resolve();
            }
          });
        } 
      });
    })
  }

  async solicitarRecarga(tank_id: number, establishment_id: number){
    this.waitAfterSave = false;
    let hacerPedido: boolean = false;
    let mensajeDeErrorPersonalizado = "Ya existe el pedido";

    await this.calcularTodosLosEstablecimiento();
    await this.cargarPedidosyRecargas()

        // Comprobar que si el pedido ya se ha realizado y no se ha recibido ninguna recarga
        const pedidosConTanqueID = this.pedidos.filter((pedido: any) => pedido.tank_id == tank_id);
        const pedidoMasAntiguo = pedidosConTanqueID[pedidosConTanqueID.length - 1];
        
        const recargasConTanqueID = this.recargas.filter((recarga: any) => recarga.tank_id == tank_id);
        const recargaMasAntigua = recargasConTanqueID[recargasConTanqueID.length - 1];
  
        if(recargasConTanqueID.length == 0 && pedidosConTanqueID.length < 0){
          hacerPedido = false;
        }
        if(recargasConTanqueID.length > 0){
          if(pedidoMasAntiguo){
            if(pedidoMasAntiguo.created_at <= recargaMasAntigua.created_at){
              hacerPedido = true;
            } else {
              hacerPedido = false;
            }
          } else {
            hacerPedido = true;
          }
        }
  
      if(!hacerPedido){
        if (!this.waitAfterSave) {
          this.waitAfterSave = true;
        }
        setTimeout(() => {
          this.waitAfterSave = false;
        },4500)
        this.toastr.error(mensajeDeErrorPersonalizado, 'Error', {
          timeOut: 4500,
          progressBar: true,
          titleClass: 'toast-family-font'
        });
      } else {
        const pedido = new FormData();
        pedido.append('_method', "PUT");
        pedido.append('establishment_id', establishment_id.toString());
        pedido.append('tank_id', tank_id.toString());
        
        this.agregarPedidoSubscription = this.deviceService.createPedido(pedido).subscribe({
          next:resp =>{
            console.log(resp);
          }, error: err => {
            if (!this.waitAfterSave) {
              this.waitAfterSave = true;
            }
            setTimeout(() => {
              this.waitAfterSave = false;
            },3500)
            this.toastr.error("Acción no permitida", 'Error', {
              timeOut: 3500,
              progressBar: true,
              titleClass: 'toast-family-font'
            });
          }, complete: () => {
            this.toastr.success('¡Pedido solicitado!','Éxito',{
              timeOut: 3500,
              progressBar: true,
              titleClass: 'toast-family-font'
            });
            if (!this.waitAfterSave) {
              this.waitAfterSave = true;
            }
            setTimeout(() => {
              this.waitAfterSave = false;
            },3500)
          }
        });
      }
  }

}
